<template>
    <section class="section_padding fligh_confirmation">
        <div class="container">
            <div class="row">
                <div class="col-md-8 m-0">
                    <div
                        v-if="this.allowed_to_request_hotel_reservation == 1 && this.essential_guest == 1 && this.is_self_paying == 0 && this.theme == 'Ewc'">
                        <form class="needs-validation" novalidate>
                            <div class="clearfix">
                                <div class="itinerary-content ib-con mb20">
                                    <div class="row no-margin align-items-center">
                                        <div class="col-md-6 col-6">
                                            <img src="@/assets/img/icons/hotels.png">
                                            <div class="inline-middle pl-3 pr-3">
                                                <h4 class="bold  mb0">{{ $t('Hotels') }}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row p10 pt-0 pb-0 mt-2">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>
                                                    {{
                                                        $t('Do you need to book a hotel?')
                                                    }}
                                                </label>
                                                <select class="form-control" v-model="is_need_booking" required>
                                                    <option value="">{{ $t('select2') }}</option>
                                                    <option value="1">{{ $t('yes') }}</option>
                                                    <option value="0">{{ $t('no') }}</option>
                                                    <option value="2">{{ $t('My organization will not cover') }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="is_need_booking == '0'" class="row p10 pt-0 pb-0 mt-2">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>
                                                    {{
                                                        $t('Hotel name')
                                                    }} :
                                                </label>
                                                <input type="text" class="form-control" :placeholder="$t('Hotel name')"
                                                    v-model="hotel_reference" required>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="is_need_booking == '1'">
                                        <div class="row align-items-center mb-3">
                                            <div v-if="this.hotel_img != null" class="col-md-12">
                                                <div class="p10">
                                                    <div class="hotel-img">
                                                        <img :src="this.hotel_img">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="row p10 pt-0 pb-0">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label style="visibility: hidden;">{{ $t('Hotel name')
                                                                }}</label>
                                                            <select v-model="hotel_id" @change="changeHotel"
                                                                class="form-control">
                                                                <option v-for="hotel in hotels" :value="hotel.id">{{
                                                                    hotel[this.$i18n.locale + '_name'] }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="col-md-12">
                                                        <div class="mb-3">
                                                            <h4 class="font-size-18 mb-3 color-label">
                                                                <span class="note">{{ $t('Note') }} :
                                                                </span>
                                                                {{ $t('You are eligible for') }}
                                                                {{ hotel_conditions.free_duration }} x
                                                                {{ $t('free nights between') }}
                                                                {{
                                                                    formattedDateRange(formatDateSafari(hotel_conditions.free_reservation_start_date),
                                                                        formatDateSafari(hotel_conditions.free_reservation_end_date))
                                                                }}
                                                            </h4>
                                                        </div>
                                                    </div> -->
                                                    <div v-if="show_hotel_note" class="col-md-12">
                                                        <h6 class="font-medium mb-3 color-label">
                                                            <span class="note">{{ $t('Note') }} :
                                                            </span>
                                                            {{ $t('accompanying guests') }}
                                                        </h6>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>{{ $t('Free reservation start date') }}</label>
                                                            <input v-if="this.tripType != 'oneway'" type="text"
                                                                class="form-control" :value="entry_hotel_date" disabled>
                                                            <VueDatePicker v-else v-model="entry_date"
                                                                :enable-time-picker="false"
                                                                :min-date="formatDateSafari(this.policy.departure_to_riyadh_from_date)"
                                                                :max-date="formatDateSafari(this.policy.departure_to_riyadh_to_date)"
                                                                :start-date="formatDateSafari(this.policy.departure_to_riyadh_from_date)"
                                                                prevent-min-max-navigation
                                                                @internal-model-change="changeEntry"
                                                                :placeholder="$t('select2')" required />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>{{ $t('Free reservation end date') }}</label>
                                                            <input type="text" class="form-control"
                                                                :value="exit_hotel_date" disabled>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>
                                                                {{
                                                                    $t('Room type')
                                                                }} :
                                                            </label>
                                                            <select class="form-control" v-model="room_type" required>
                                                                <option value="">{{ $t('select2') }}</option>
                                                                <option value="King Bed">{{ $t('King bed') }}</option>
                                                                <option value="Double Bed">{{ $t('Twin beds') }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="need_extra_end" class="row p10 pt-0 pb-0">
                                            <div class="col-md-12 pl-5 pr-5">
                                                <hr>
                                            </div>
                                            <div class="col-md-12 text-center mt-3 mb-3">
                                                <div class="mb-3">
                                                    <h4 class="font-size-18 mb-3 text-danger">
                                                        <span class="note">{{ $t('Note') }} :
                                                        </span>
                                                        {{ $t('Saudi Cup will not cover extra nights') }}
                                                    </h4>
                                                </div>
                                            </div>
                                            <div v-if="confirm == 1" class="col-md-12 mb-3">
                                                <div class="form-group">
                                                    <label>
                                                        {{
                                                            $t('do you want to book by yourself or need assistance')
                                                        }}
                                                    </label>
                                                    <a href="javascript:void(0);" @click="this.confirm = null"
                                                        class="pull-right bold mb-1">
                                                        {{ $t('back') }}
                                                        <i class="fl-30-ico fl-fare-rules-green"></i>
                                                    </a>
                                                    <select class="form-control" v-model="need_assistance" required>
                                                        <option value="">{{ $t('select2') }}</option>
                                                        <option value="0">{{ $t('I want book by myself') }}</option>
                                                        <option value="1">
                                                            {{
                                                                $t('I need assistance') }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="need_assistance == 1 && confirm == 1 && need_extra_end"
                                            class="row p10 pt-0 pb-0">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>{{ $t('Number of nights') }}</label>
                                                    <input type="text" class="form-control" :value="count_extra_end"
                                                        disabled>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('Check-in date') }}</label>
                                                    <input type="text" class="form-control" :value="exit_hotel_date"
                                                        disabled>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('Check-out date') }}</label>
                                                    <input type="text" class="form-control" :value="end_extra_date"
                                                        disabled>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mb-3">
                                                <div class="form-group">
                                                    <label>
                                                        {{
                                                            $t('Room type')
                                                        }} :
                                                    </label>
                                                    <select class="form-control" v-model="extra_room_type" required>
                                                        <option value="">{{ $t('select2') }}</option>
                                                        <option value="King Bed">{{ $t('King bed') }}</option>
                                                        <option value="Double Bed">{{ $t('Twin beds') }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="confirm == null && need_extra_end"
                                            class="col-md-12 text-center mb-4 justify-content-center d-flex gap-5 opt-btn-div">
                                            <input type="text" v-model="confirm" class="d-none" required>
                                            <button type="button" class="btn btn_theme_two pl-0 pr-0 btn_md w-25"
                                                onclick="window.location = '/flight-search-result';">
                                                <h5 class="inline-middle bold mr5 ml5">{{ $t('select different flight')
                                                    }}
                                                </h5>
                                            </button>
                                            <button type="button" class="btn btn_theme btn_md w-25 pl-0 pr-0"
                                                @click="this.confirm = 1;">
                                                <h5 class="inline-middle bold mr5 ml5">{{ $t('confirm my choice') }}
                                                </h5>
                                            </button>
                                        </div>
                                    </div>
                                    <div v-else-if="is_need_booking == '2'">
                                        <div class="row p10 pt-0 pb-0 mt-2">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('reservation start date') }}</label>
                                                    <input v-if="this.tripType != 'oneway'" type="text"
                                                        class="form-control" :value="entry_hotel_date" disabled>
                                                    <VueDatePicker v-else v-model="entry_date"
                                                        :enable-time-picker="false"
                                                        :min-date="formatDateSafari(this.policy.departure_to_riyadh_from_date)"
                                                        :max-date="formatDateSafari(this.policy.departure_to_riyadh_to_date)"
                                                        :start-date="formatDateSafari(this.policy.departure_to_riyadh_from_date)"
                                                        prevent-min-max-navigation @internal-model-change="changeEntry"
                                                        :placeholder="$t('select2')" required />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('reservation end date') }}</label>
                                                    <input type="text" class="form-control"
                                                        :value="new Date(this.departure_time_for_riyadh).toLocaleDateString('sv-SE')"
                                                        disabled>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div v-if="is_self_paying == 1 && sp_can_book_hotel && need_payment == 0 && this.theme == 'Ewc'">
                        <form class="needs-validation" novalidate>
                            <div class="clearfix">
                                <div class="itinerary-content ib-con mb20">
                                    <div class="row no-margin align-items-center">
                                        <div class="col-md-6 col-6">
                                            <img src="@/assets/img/icons/hotels.png">
                                            <div class="inline-middle pl-3 pr-3">
                                                <h4 class="bold  mb0">{{ $t('Hotels') }}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row p10 pt-0 pb-0 mt-2">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>
                                                    {{
                                                        $t('Do you need to book a hotel?')
                                                    }}
                                                </label>
                                                <select class="form-control" v-model="is_need_booking" required>
                                                    <option value="">{{ $t('select2') }}</option>
                                                    <option value="1">{{ $t('yes') }}</option>
                                                    <option value="0">{{ $t('no') }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="is_need_booking == '0'" class="row p10 pt-0 pb-0 mt-2">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>
                                                    {{
                                                        $t('Hotel name')
                                                    }} :
                                                </label>
                                                <input type="text" class="form-control" :placeholder="$t('Hotel name')"
                                                    v-model="hotel_reference" required>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="is_need_booking == '1'">
                                        <div class="row align-items-center mb-3">
                                            <div v-if="this.hotel_img != null" class="col-md-12">
                                                <div class="p10">
                                                    <div class="hotel-img">
                                                        <img :src="this.hotel_img">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="row p10 pt-0 pb-0">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>{{ $t('Hotel name') }} :</label>
                                                            <select v-model="hotel_id" @change="changeHotel"
                                                                class="form-control">
                                                                <option v-for="hotel in hotels" :value="hotel.id">{{
                                                                    hotel[this.$i18n.locale + '_name'] }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>{{ $t('reservation start date') }} :</label>
                                                            <input v-if="this.tripType != 'oneway'" type="text"
                                                                class="form-control" :value="entry_hotel_date" disabled>
                                                            <VueDatePicker v-else v-model="entry_date"
                                                                :enable-time-picker="false"
                                                                :min-date="formatDateSafari(this.policy.departure_to_riyadh_from_date)"
                                                                :max-date="formatDateSafari(this.policy.departure_to_riyadh_to_date)"
                                                                :start-date="formatDateSafari(this.policy.departure_to_riyadh_from_date)"
                                                                prevent-min-max-navigation
                                                                @internal-model-change="changeEntry"
                                                                :placeholder="$t('select2')" required />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>{{ $t('reservation end date') }} :</label>
                                                            <input type="text" class="form-control"
                                                                :value="exit_hotel_date" disabled>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>{{ $t('room price') }} :</label>
                                                            <input type="text" class="form-control" :value="room_price"
                                                                disabled>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>
                                                                {{
                                                                    $t('Room type')
                                                                }} :
                                                            </label>
                                                            <select class="form-control" v-model="room_type" required>
                                                                <option value="">{{ $t('select2') }}</option>
                                                                <option value="King Bed">{{ $t('King bed') }}</option>
                                                                <option value="Double Bed">{{ $t('Twin beds') }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div v-if="confirm == null && need_start_extra"
                                                        class="col-md-12 text-center mt-2 mb-2">
                                                        <input type="text" v-model="confirm" class="d-none" required>
                                                        <div class="mb-3">
                                                            <h4 class="font-size-18 mb-3 text-danger">
                                                                <span class="note">{{ $t('Note') }} :
                                                                </span>
                                                                {{ $t('Add an extra day to the start?') }}
                                                            </h4>
                                                        </div>
                                                        <div class="justify-content-center d-flex gap-5 opt-btn-div">
                                                            <button type="button"
                                                                class="btn btn_theme_danger pl-0 pr-0 btn_md w-25"
                                                                @click="setConfirmMyChoice(false)">
                                                                <h5 class="inline-middle bold mr5 ml5">
                                                                    {{ $t('no') }}
                                                                </h5>
                                                            </button>
                                                            <button type="button"
                                                                class="btn btn_theme btn_md w-25 pl-0 pr-0"
                                                                @click="setConfirmMyChoice(true)">
                                                                <h5 class="inline-middle bold mr5 ml5">
                                                                    {{ $t('yes') }}
                                                                </h5>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div v-if="this.tripType != 'multi_city'">
                        <selected-flight v-if="flightOffers.length > 0" :flight="departure_flight" :type="0"
                            :img="this.getOutboundImg" :searchData="searchData"></selected-flight>
                    </div>
                    <div v-if="this.tripType == 'roundtrip'">
                        <selected-flight v-if="flightOffers.length > 0" :flight="arrival_flight" :type="1"
                            :img="this.getInboundImg" :searchData="searchData"></selected-flight>
                    </div>
                    <div v-if="this.tripType == 'multi_city'">
                        <multi-selected-flight v-if="flightOffers.length > 0" :flight="departure_flight"
                            :getOutboundImg="getOutboundImg" :getInboundImg="getInboundImg" :searchData="searchData">
                        </multi-selected-flight>
                    </div>
                    <passengers :passengers="passengers"></passengers>
                    <div v-if="this.allow_sitemap == '1' || this.allowed_to_request_additional_weight == '1'"
                        class="itinerary-content mb20">
                        <div class="row no-margin">
                            <div class="col-md-12">
                                <img src="@/assets/img/svg/noun-flight.svg" width="35">
                                <h4 class="no-margin  inline-middle pl-3 pr-3">
                                    {{ $t('Extra Add ons') }}
                                </h4>
                            </div>
                        </div>
                        <div>
                            <div class="drawer-bar drawer-black">
                                <button v-if="this.allow_sitemap == '1'" type="button"
                                    v-bind:class="'drawer-bar-item drawer-button active' + (this.allow_sitemap == '1' && this.allowed_to_request_additional_weight == '0' ? ' w-100' : '')"
                                    data-id=".drawer-container.seats">
                                    {{ $t('Seats Selection') }}
                                </button>
                                <button v-if="this.allowed_to_request_additional_weight == '1'" type="button"
                                    v-bind:class="'drawer-bar-item drawer-button' + (this.allow_sitemap == '0' && this.allowed_to_request_additional_weight == '1' ? ' active w-100' : '')"
                                    data-id=".drawer-container.bags">
                                    {{ $t('Baggage Selection') }}
                                </button>
                            </div>
                            <div v-if="this.allowed_to_request_additional_weight == '1'" class="drawer-container bags"
                                :style="(this.allow_sitemap == '1' ? 'display: none;' : '')">
                                <div v-if="bags.length > 0">
                                    <div v-if="!addBags && !is_bags_confirmed" class="row align-items-center">
                                        <div class="col-md-12">
                                            <div class="p20">
                                                <div class="hotel-img">
                                                    <img src="@/assets/img/airport-luggage.avif">
                                                </div>
                                                <div class="d-flex justify-content-between mt-4">
                                                    <div class="price-block one-of-more">
                                                        <h4 class="bold">{{ $t('Add additional baggage') }}</h4>
                                                        <div class="exbag-attributes one-of-more">
                                                            <span v-if="flightOffers.length > 0">
                                                                {{ $t('baggage included in your booking') }}
                                                                {{
                                                                    getFareDetailsBySegmentId(departure_flight.travelerPricings,
                                                                        departure_flight
                                                                            .itineraries[0].segments[0].id) }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <button type="button" class="btn btn_theme btn_md w-30 pt-2 pb-2"
                                                        @click="this.addBags = true;">
                                                        <h5 class="inline-middle bold mr5 ml5">
                                                            {{ $t('Baggage Selection') }}
                                                        </h5>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="row align-items-center">
                                            <div class="col-md-12">
                                                <div class="p20">
                                                    <div class="hotel-img">
                                                        <img src="@/assets/img/airport-luggage.avif">
                                                    </div>
                                                    <div class="mt-4">
                                                        <img src="@/assets/img/svg/img_icon_flighttake_off.svg">
                                                        <div class="inline-middle pl-3 pr-3">
                                                            <h4 class="new-bold-light bold mb0">
                                                                {{ $t('Departure Flight') }}
                                                            </h4>
                                                            <span class="dep-date font-14">
                                                                {{
                                                                    getFormattedDate(departure_flight.itineraries[0].segments[0].departure.at)
                                                                }}
                                                            </span>
                                                        </div>
                                                        <div v-for="(passenger, index) in passengers"
                                                            class="d-flex justify-content-between align-items-center"
                                                            style="min-height: 100px;border-bottom: 1px solid #dedede;">
                                                            <div class="price-block one-of-more w-50">
                                                                <h4 class="bold">
                                                                    {{ passenger.first_name }}
                                                                    {{ passenger.last_name }}
                                                                </h4>
                                                                <p>{{ $t('baggage included in your booking') }} {{
                                                                    getFareDetailsBySegmentId(departure_flight.travelerPricings,
                                                                        departure_flight
                                                                            .itineraries[0].segments[0].id) }}</p>
                                                            </div>
                                                            <div class="form-group w-50">
                                                                <label>
                                                                    {{
                                                                        $t('Additional baggage')
                                                                    }}
                                                                </label>
                                                                <select v-model="departure_selected_bags[index]"
                                                                    class="form-control" :disabled="is_bags_confirmed">
                                                                    <option value="">{{ $t('select2') }}</option>
                                                                    <option v-for="bag in bags[0].baggage" :value="bag">
                                                                        {{ bag.quantity }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="this.tripType != 'oneway'" class="mt-4">
                                                        <div class="col-md-6 col-6">
                                                            <img src="@/assets/img/svg/img_icon_flightlanding.svg">
                                                            <div class="inline-middle pl-3 pr-3">
                                                                <h4 class="new-bold-light bold mb0">
                                                                    {{ $t('Return Flight') }}
                                                                </h4>
                                                                <span class="dep-date font-14">
                                                                    {{
                                                                        getFormattedDate(arrival_flight.itineraries[1].segments[0].departure.at)
                                                                    }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div v-for="(passenger, index) in passengers"
                                                            class="d-flex justify-content-between align-items-center"
                                                            style="min-height: 100px;border-bottom: 1px solid #dedede;">
                                                            <div class="price-block one-of-more w-50">
                                                                <h4 class="bold">
                                                                    {{ passenger.first_name }}
                                                                    {{ passenger.last_name }}
                                                                </h4>
                                                                <p>{{ $t('baggage included in your booking') }} {{
                                                                    getFareDetailsBySegmentId(arrival_flight.travelerPricings,
                                                                        arrival_flight
                                                                            .itineraries[0].segments[0].id) }}</p>
                                                            </div>
                                                            <div class="form-group w-50">
                                                                <label>
                                                                    {{
                                                                        $t('Additional baggage')
                                                                    }}
                                                                </label>
                                                                <select v-model="arrival_selected_bags[index]"
                                                                    class="form-control" :disabled="is_bags_confirmed">
                                                                    <option value="">{{ $t('select2') }}</option>
                                                                    <option v-for="bag in bags[1].baggage" :value="bag">
                                                                        {{ bag.quantity }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="d-flex align-items-center align-items-center"
                                        style="justify-content: center;min-height: 300px;">
                                        <h3>{{ $t('There are no options available.') }}</h3>
                                    </div>
                                </div>
                            </div>
                            <div v-if="this.allow_sitemap == '1'" class="drawer-container seats">
                                <div>
                                    <div v-if="!selectSeats" class="row align-items-center mb-3">
                                        <div class="col-md-12">
                                            <div class="p20">
                                                <div class="hotel-img">
                                                    <img src="@/assets/img/seat-card.avif">
                                                </div>
                                                <div class="d-flex justify-content-between mt-4">
                                                    <div class="price-block one-of-more">
                                                        <h4 class="bold">{{ $t('Choose seats') }}</h4>
                                                        <div class="exbag-attributes one-of-more">
                                                            <span>{{ $t('For a Regular seat') }}</span>
                                                        </div>
                                                    </div>
                                                    <button type="button" class="btn btn_theme btn_md w-30 pt-2 pb-2"
                                                        @click="this.selectSeats = true;">
                                                        <h5 class="inline-middle bold mr5 ml5">
                                                            {{ $t('Seats Selection') }}
                                                        </h5>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="p-seatmap">
                                        <div class="seatmap-container">
                                            <div class="content">
                                                <div class="seat-selection-wrapper">
                                                    <div v-for="flight in seatmap" class="group">
                                                        <p class="flight">
                                                            {{ flight.departure.iataCode }} - {{ flight.arrival.iataCode
                                                            }}
                                                        </p>
                                                        <a v-for="(passenger, index) in passengers"
                                                            title="Select Passenger"
                                                            v-bind:class="`passenger condensed-item ${travelerId == index + 1 && segmentId == flight.segmentId ? 'active' : ''}`"
                                                            @click="select_passenger(index + 1, flight.segmentId)">
                                                            {{ passenger.first_name }}
                                                            {{ passenger.last_name }}:
                                                            {{ passenger_seat(flight.segmentId, index + 1) }}
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="seat-map-wrapper">
                                                    <div class="aircraft">
                                                        <div class="cabins-wrapper">
                                                            <div class="cabin">
                                                                <div v-for="(row, index) in seatsRows" class="row-div">
                                                                    <div v-for="seat in row"
                                                                        v-bind:class="(seat == null ? 'aisle ' : 'seat-wrapper ') + (exitRowsX?.includes(index) ? ' extra-legroom emergency-exit-row ' : '')"
                                                                        v-tooltip.top="seat?.tooltip">
                                                                        <div v-if="seat != null"
                                                                            v-bind:class="`mat-tooltip-trigger seat ${seat?.status} ${is_seat_selected(segmentId, seat.number)}`"
                                                                            @click="selectSeat(seat)">
                                                                            <div class="seat-number">
                                                                                <div>{{ seat?.number }}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="footer">
                                                <div class="legend-outer-wrapper">
                                                    <button type="button" class="btn btn_theme btn_md w-50 pt-2 pb-2"
                                                        :disabled="!canSubmitSeats">
                                                        <h5 class="inline-middle bold mr5 ml5">
                                                            {{ $t('confirm my choice') }}
                                                        </h5>
                                                    </button>
                                                </div>
                                                <div class="legend-outer-wrapper">
                                                    <div class="legend-inner-wrapper">
                                                        <div class="legend">
                                                            <div class="info-box available"></div>
                                                            <span class="label">Available</span>
                                                        </div>
                                                        <div class="legend">
                                                            <div class="info-box blocked"></div>
                                                            <span class="label">Blocked</span>
                                                        </div>
                                                        <div class="legend">
                                                            <div class="info-box occupied"></div>
                                                            <span class="label">Occupied</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="addBags && !is_bags_confirmed && (!arrival_selected_bags.every(item => item == '') || !departure_selected_bags.every(item => item == ''))"
                                class="row text-center mb-3">
                                <div class="col-md-12">
                                    <button @click="confirm_my_choice" type="button"
                                        class="btn btn_theme btn_md w-50 pt-2 pb-2">
                                        <h5 class="inline-middle bold mr5 ml5">
                                            {{ $t('confirm my choice') }}
                                        </h5>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="need_payment == 1 && show_payment_form">
                        <div class="tour_details_right_sidebar_wrapper">
                            <div class="tour_detail_right_sidebar">
                                <div class="tour_details_right_boxed">
                                    <div class="row no-margin align-items-center">
                                        <div class="col-md-6 col-6">
                                            <img src="@/assets/img/svg/card.svg">
                                            <div class="inline-middle pl-3 pr-3">
                                                <h4 class="bold  mb0">{{ $t('payment information') }}</h4>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="tour_booking_amount_area">
                                                <ul>
                                                    <li v-for="(item, index) in guest_packages"
                                                        v-bind:class="index == guest_packages.length - 1 ? 'last' : ''">
                                                        {{ item.service['service_name_' + $i18n.locale] }}
                                                        <span>
                                                            {{
                                                                item.service.service_name_en == "Flights" ?
                                                                    parseFloat(total).toFixed(2) :
                                                                    parseFloat(item.price).toFixed(2)
                                                            }}
                                                            {{ $t('SAR') }}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        {{ $t('Total Amount') }}
                                                        <span class="text-main">
                                                            {{ parseFloat(total_amount).toFixed(2) }}
                                                            {{ $t('SAR') }}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        {{ $t('discount') }}
                                                        <span class="text-danger">
                                                            {{ parseFloat(discount).toFixed(2) }}
                                                            {{ $t('SAR') }}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        {{ $t('Amount due') }}
                                                        <span class="text-main">
                                                            {{ parseFloat(amount_due).toFixed(2) }}
                                                            {{ $t('SAR') }}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div v-if="payment_method == ''" class="col-md-12 mt-3">
                                            <div class="form-group">
                                                <label>
                                                    {{ $t('payment method') }}
                                                </label>
                                                <select class="form-control" v-model="payment_method"
                                                    @change="payment_method_change" required>
                                                    <option value="">{{ $t('select2') }}</option>
                                                    <option value="MADA">MADA</option>
                                                    <option value="VISA MASTER">VISA MASTER</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="mt-3">
                                                <form id="payment_form"
                                                    :action="saudi_cup_url + '/api/result/' + checkoutId + '?redirect_url=' + payment_redirect_url"
                                                    class="paymentWidgets" :data-brands="payment_method"></form>
                                            </div>
                                        </div>
                                        <div v-if="is_payment_loading == 1"
                                            class="col-md-12 text-center mt-5 mb-5 pt-5 pb-5">
                                            <lv-loader type="ball-pulse" :scale="1.3" :color="'#d1b26e'" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 sticky-parent">
                    <div class="tour_details_right_sidebar_wrapper">
                        <div class="tour_detail_right_sidebar mb20">
                            <div class="tour_details_right_boxed">
                                <div class="row text-center">
                                    <div class="col-md-12">
                                        <div v-if="this.tripType == 'multi_city'" v-for="(item, index) in from"
                                            class="d-flex space-evenly align-items-center text-center p5 mt-2 mb-2">
                                            <div class="inline-block w-30 vertical-middle">
                                                <h3 class="bold from-txt mb0 prime-color">{{ item }}</h3>
                                                <span class="clearfix from-full-txt">
                                                    {{ getCityByCode(item) }}
                                                </span>
                                            </div>
                                            <div class="inline-block vertical-middle">
                                                <img src="@/assets/img/svg/noun-one-way.svg">
                                            </div>
                                            <div class="inline-block w-30 vertical-middle">
                                                <h3 class="bold to-txt mb0 prime-color colorprime">
                                                    {{ to[index] }}
                                                </h3>
                                                <span class="clearfix to-full-txt to-full-txt">
                                                    {{ getCityByCode(to[index]) }}
                                                </span>
                                            </div>
                                        </div>
                                        <div v-else class="d-flex space-evenly align-items-center text-center p5 mt-2">
                                            <div class="inline-block vertical-middle">
                                                <h3 class="bold from-txt mb0 prime-color">{{ searchData.from }}</h3>
                                                <span class="clearfix from-full-txt">
                                                    {{ getCityByCode(searchData?.from) }}
                                                </span>
                                            </div>
                                            <div class="inline-block vertical-middle">
                                                <img v-if="this.tripType == 'oneway'"
                                                    src="@/assets/img/svg/noun-one-way.svg">
                                                <img v-else-if="this.tripType == 'roundtrip'"
                                                    src="@/assets/img/svg/noun-round-trip.svg">
                                            </div>
                                            <div class="inline-block vertical-middle">
                                                <h3 class="bold to-txt mb0 prime-color colorprime">{{ searchData.to }}
                                                </h3>
                                                <span class="clearfix to-full-txt to-full-txt">
                                                    {{ getCityByCode(searchData?.to) }}
                                                </span>
                                            </div>
                                        </div>
                                        <hr class="dash-line">
                                        <div class="text-initial">
                                            <img src="@/assets/img/svg/noun-calendar.svg">
                                            <div v-if="this.tripType == 'multi_city'"
                                                class="inline-middle font-medium mr-3 ml-3">
                                                <div class="inline-middle">{{ getFormattedDate(date[0]) }}</div>
                                                <span style="display: inline;">
                                                    <span>&emsp;-&emsp;</span>
                                                    <div class="inline-middle">
                                                        <span class="return-date-txt">{{
                                                            getFormattedDate(date[1]) }}</span>
                                                    </div>
                                                </span>
                                            </div>
                                            <div v-else class="inline-middle font-medium mr-3 ml-3">
                                                <div class="inline-middle">{{
                                                    getFormattedDate(formatDateSafari(searchData.date)) }}</div>
                                                <span v-if="this.tripType != 'oneway'" style="display: inline;">
                                                    <span>&emsp;-&emsp;</span>
                                                    <div class="inline-middle">
                                                        <span class="return-date-txt">{{
                                                            getFormattedDate(formatDateSafari(searchData.ret_date))
                                                        }}</span>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                        <hr class="dash-line">
                                        <div class="text-initial">
                                            <img src="@/assets/img/svg/noun-passengers.svg">
                                            <div class="inline-middle font-medium mr-3 ml-3">
                                                <div class="inline-middler">
                                                    {{ passengers.length }}
                                                    {{ $t('traveller') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="need_payment == 0 && show_send_btn">
                                            <hr class="dash-line">
                                            <div class="form-group mt-4">
                                                <div class="form-check">
                                                    <label class="form-check-label">
                                                        <span class="area_flex_one justify-content-center">
                                                            <div class="ripple-checkbox-primary">
                                                                <input class="inp-cbx" id="confirm" type="checkbox"
                                                                    v-model="confirm_issue" style="display: none">
                                                                <label class="cbx m-0" for="confirm">
                                                                    <span>
                                                                        <svg width="12px" height="10px"
                                                                            viewBox="0 0 12 10">
                                                                            <polyline points="1.5 6 4.5 9 10.5 1">
                                                                            </polyline>
                                                                        </svg>
                                                                    </span>
                                                                </label>
                                                            </div>
                                                            <span class="text-danger text-initial pl-3 pr-3 pt-0 w-100">
                                                                {{ $t("confirm note") }}
                                                                <br>
                                                                {{ $t("confirm note2") }}
                                                            </span>
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="ticket-hole">
                                                <hr class="dash-line">
                                            </div>
                                            <button type="button" class="btn btn_theme btn_md w-100 mt-4" @click="send"
                                                :disabled="check_guest_loader || !confirm_issue">
                                                {{ confirm_issue ?
                                                    $t('Confirm the reservation and issue the ticket') :
                                                    $t('agree to terms conditions')
                                                }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
var that;
import $ from 'jquery';
import jsonData from '@/assets/file/airports-v2.json';
import jsonDataEn from '@/assets/file/en-airports.json';
import airlinesData from '@/assets/file/airlines.json';
import Tooltip from 'lightvue/tooltip';
import { toast } from 'vue3-toastify';
import LvLoader from 'lightvue/loaders';
import { addDaysToDate, decreaseDayFromDate, formatDate, formattedDateRange, frCaDateFormat, needAnExtraDayAtBeginning } from '@/utils/dateUtils';
import { convertDuration, formatTime } from '@/utils/timeUtils';
import flightsService from '@/services/jsky/flights/flights-service';
import LvDialog from 'lightvue/dialog';
import LvButton from 'lightvue/button';
import { GoogleMap, Marker } from 'vue3-google-map';
import LvProgressSpinner from 'lightvue/progress-spinner';
import guestService from '@/services/saudi-cup/guest/guest-service';
import { getTotalPriceWithMarkup } from '@/utils/priceUtils';
import { countExtraDayAtEnd, needAnExtraDayAtEnd } from '../../utils/dateUtils';
import SelectedFlight from './SelectedFlight.vue';
import MultiSelectedFlight from './MultiSelectedFlight.vue';
import Passengers from './Passengers.vue';
import countriesData from '@/assets/file/countries.json';
import paymentService from '@/services/saudi-cup/payment/payment-service';
import airlineService from '@/services/saudi-cup/airline/airline-service';
export default {
    name: 'FlightConfirmationArea',
    directives: {
        tooltip: Tooltip,
    },
    data: () => ({
        date: '',
        ret_date: '',
        departure: null,
        arrival: null,
        departure_flight: null,
        arrival_flight: null,
        airlines: [],
        passengers: [],
        flightOffers: [],
        searchData: [],
        getOutboundImg: '',
        getInboundImg: '',
        tripType: '',
        from: [],
        to: [],
        allowed_to_request_hotel_reservation: 0,
        hotels: [],
        hotel_img: '',
        hotel_conditions: [],
        hotel_id: '',
        current_hotel: [],
        room_type: '',
        extra_room_type: '',
        arrival_time_to_riyadh: '',
        departure_time_for_riyadh: '',
        entry_hotel_date: '',
        exit_hotel_date: '',
        need_extra_end: false,
        need_assistance: '',
        count_extra_end: false,
        end_extra_date: '',
        essential_guest: 0,
        confirm: null,
        confirm_issue: false,
        entry_date: null,
        total: 0,
        need_payment: 1,
        is_self_paying: 1,
        is_payment_loading: 0,
        payment_method: '',
        checkoutId: '',
        payment_redirect_url: '',
        markup: 0,
        hotel_reference: '',
        stay_type: '',
        registration_number: '',
        stay_with_friend: '',
        is_need_booking: '',
        policy: [],
        displayLvDialog: false,
        markerPosition: null,
        location: null,
        check_guest_loader: false,
        registration_number_verified: null,
        max_ticket_price: 0,
        total_amount: 0,
        amount_due: 0,
        discount: 0,
        sp_can_book_hotel: false,
        guest_packages: [],
        guest_data: [],
        need_start_extra: false,
        saudi_cup_url: process.env.VUE_APP_SAUDI_CUP_URL,
        main_guest_id: null,
        redirect_url: null,
        show_send_btn: true,
        show_payment_form: true,
        departure_period: null,
        return_period: null,
        seatmap: null,
        saets: [],
        travelerId: null,
        segmentId: null,
        width: null,
        startSeatRow: null,
        endSeatRow: null,
        exitRowsX: [],
        seatSelect: [],
        canSubmitSeats: false,
        seatsRows: [],
        selectSeats: false,
        addBags: false,
        bags: [],
        allowed_to_request_additional_weight: 0,
        allow_sitemap: 0,
        room_price: 0,
        departure_selected_bags: [],
        arrival_selected_bags: [],
        bags_price: [],
        is_bags_confirmed: false,
        show_hotel_note: false,
        theme: ''
    }),
    components: {
        LvLoader,
        GoogleMap,
        Marker,
        LvDialog,
        LvButton,
        LvProgressSpinner,
        SelectedFlight,
        MultiSelectedFlight,
        Passengers
    },
    methods: {
        formatDateSafari(date) {
            return new Date(String(date).replace(/undefined-undefined-/g, '').replace(/-/g, '/'));
        },
        confirm_my_choice() {
            var total = 0;
            var selected = [];

            this.is_bags_confirmed = true;
            $('.pre-loader').show();

            localStorage.setItem("is_bags_confirmed", this.is_bags_confirmed);
            localStorage.setItem("departure_selected_bags", JSON.stringify(this.departure_selected_bags));
            localStorage.setItem("arrival_selected_bags", JSON.stringify(this.arrival_selected_bags));

            this.departure_selected_bags.forEach((element, index) => {
                if (element) {
                    this.flightOffers[0].travelerPricings[index].fareDetailsBySegment.forEach(segment => {
                        if (element.segmentIds.includes(segment.segmentId)) {
                            segment['additionalServices'] = {
                                "chargeableCheckedBags": {
                                    "quantity": element.quantity
                                }
                            };
                            selected.push({ 'segmentId': segment.segmentId, 'quantity': element.quantity });
                        }
                    });
                    total += parseFloat(element.price.amount);
                }
            });

            this.arrival_selected_bags.forEach((element, index) => {
                if (element) {
                    this.flightOffers[0].travelerPricings[index].fareDetailsBySegment.forEach(segment => {
                        if (element.segmentIds.includes(segment.segmentId)) {
                            segment['additionalServices'] = {
                                "chargeableCheckedBags": {
                                    "quantity": element.quantity
                                }
                            };
                            selected.push({ 'segmentId': segment.segmentId, 'quantity': element.quantity });
                        }
                    });
                    total += parseFloat(element.price.amount);
                }
            });

            this.flightOffers[0].price['additionalServices'] = [{
                "amount": String(total),
                "type": "CHECKED_BAGS"
            }];
            this.flightOffers[0].price['grandTotal'] = String(parseFloat(this.flightOffers[0].price['grandTotal']) + total);

            this.flight_offers_pricing_with_bags(this.flightOffers[0]);
        },
        getFareDetailsBySegmentId(travelerPricings, segmentId) {
            var travelerPricing = travelerPricings[0].fareDetailsBySegment.filter(item => {
                return item.segmentId == segmentId;
            });
            if (travelerPricing.length) {
                travelerPricing = travelerPricing[0];
                if (travelerPricing.includedCheckedBags.quantity != null) {
                    return `${travelerPricing.includedCheckedBags.quantity}`;
                } else {
                    return `${travelerPricing.includedCheckedBags.weight} ${travelerPricing.includedCheckedBags.weightUnit}`;
                }
            }
            return 0;
        },
        selectSeat(seat) {
            var selected = this.seatSelect.some(s => s.segmentId == this.segmentId && s.seatCode == seat.number);
            if (seat.status === 'available' && !selected) {
                this.seatSelect = this.seatSelect.filter(s =>
                    !(s.segmentId == this.segmentId && s.travelerId == this.travelerId)
                );
                this.seatSelect.push({
                    segmentId: this.segmentId,
                    travelerId: this.travelerId,
                    seatCode: seat.number,
                });
                this.goToNextTravelerOrSegment();
            }
        },
        is_seat_selected(segmentId, seatCode) {
            var is_selected = this.seatSelect.find(seat => seat.segmentId == segmentId && seat.seatCode == seatCode);
            return is_selected != null ? 'selected' : '';
        },
        passenger_seat(segmentId, travelerId) {
            var seat = this.seatSelect.find(seat => seat.segmentId == segmentId && seat.travelerId == travelerId);
            return seat != null ? seat.seatCode : '';
        },
        select_passenger(travelerId, segmentId) {
            this.travelerId = `${travelerId}`;
            this.segmentId = segmentId;
            const seats = this.seatmap.find(seat => seat.segmentId == segmentId);

            var deckConfiguration = seats.decks[0].deckConfiguration;
            this.width = deckConfiguration.width;
            this.startSeatRow = deckConfiguration.startSeatRow;
            this.endSeatRow = deckConfiguration.endSeatRow;
            this.exitRowsX = deckConfiguration.exitRowsX;

            var seatsRows = [];
            seatsRows[segmentId] = Array.from({ length: (this.endSeatRow - this.startSeatRow) }, () =>
                Array(this.width).fill(null)
            );
            // seats.decks[0].facilities.forEach(seat => {
            //     seatsRows[segmentId] = seatsRows[segmentId] || [];
            //     seatsRows[segmentId][seat.coordinates.x] = seatsRows[segmentId][seat.coordinates.x] || [];
            //     seat.status = 'facilities';
            //     seat.number = seat.code;
            //     seat.tooltip = `<div class="text-center"><div>${this.seatData['dictionaries']['facilities'][seat.code]}</div></div>`;
            //     seatsRows[segmentId][seat.coordinates.x][seat.coordinates.y] = seat;
            // });
            seats.decks[0].seats.forEach(seat => {
                seatsRows[segmentId] = seatsRows[segmentId] || [];
                seatsRows[segmentId][seat.coordinates.x] = seatsRows[segmentId][seat.coordinates.x] || [];
                const traveler_pricing = this.getTravelerPricing(seat);
                seat.status = traveler_pricing.seatAvailabilityStatus.toLowerCase();
                if (traveler_pricing.seatAvailabilityStatus.toLowerCase() == 'available') {
                    seat.tooltip = `<div>`;
                    seat.characteristicsCodes.forEach(element => {
                        seat.tooltip += `<div>${this.seatData['dictionaries']['seatCharacteristics'][element]}</div>`;
                    });
                    if (this.is_self_paying == 1) {
                        seat.tooltip += `<div class='d-flex justify-content-between bold'><span>${seat.number}</span><span>${traveler_pricing.price?.total}<span class="text-main"> SAR</span></span></div></div>`;
                    } else {
                        seat.tooltip += `</div>`;
                    }
                } else {
                    seat.tooltip = null;
                }
                seatsRows[segmentId][seat.coordinates.x][seat.coordinates.y] = seat;
            });
            this.seatsRows = seatsRows[segmentId];
        },
        goToNextTravelerOrSegment() {
            const travelers = [...this.passengers];
            const segments = [...this.seatmap];
            const currentTravelerIndex = this.travelerId;
            const currentSegmentIndex = segments.findIndex(s => s.segmentId == this.segmentId);
            if (currentTravelerIndex < travelers.length) {
                this.select_passenger(parseInt(currentTravelerIndex) + 1, this.segmentId);
            } else if (currentSegmentIndex < segments.length - 1) {
                this.select_passenger(1, segments[currentSegmentIndex + 1].segmentId);
            } else {
                this.canSubmitSeats = true;
            }
        },
        getTravelerPricing(seat) {
            if (!seat.travelerPricing || !Array.isArray(seat.travelerPricing)) {
                return null;
            }
            return seat.travelerPricing.find(pricing => pricing.travelerId == this.travelerId) || null;
        },
        getCityByCode(code) {
            var info = jsonData.filter(item => {
                return item.code.includes(code);
            });
            return info.length > 0 ? info[0][this.$i18n.locale + '_city'] : null;
        },
        getFormattedDate(dateString) {
            const { day, month, year } = formatDate(dateString);
            return `${day} ${this.$t(month)} ${year}`;
        },
        setConfirmMyChoice(value) {
            this.confirm = value;
            if (value == false) {
                this.entry_hotel_date = this.add_days_to_date(this.arrival_time_to_riyadh, 0);
            }
        },
        handleChangeRegistrationNumber() {
            this.check_guest_loader = true;
        },
        check_guest_exists() {
            if (!this.registration_number || this.registration_number_verified) return;
            this.check_guest_loader = true;
            guestService.check_guest_exists(this.registration_number).then(response => {
                var res = response.data.data;
                this.main_guest_id = res.id;
                this.check_guest_loader = false;
                this.registration_number_verified = true;
            }).catch(error => {
                this.registration_number_verified = false;
                this.check_guest_loader = false;
                this.registration_number = null;
                toast.error(this.$t('Invalid registration number'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
            });
        },
        handleMapClick(event) {
            const latLng = event.latLng;
            this.markerPosition = {
                lat: latLng.lat(),
                lng: latLng.lng(),
            };
            this.getAddressFromCoordinates(latLng);
        },
        getAddressFromCoordinates(latLng) {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: latLng }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                    const place = results[0];
                    const address = place.formatted_address;
                    this.location = {
                        "lat": latLng.lat(),
                        "lng": latLng.lng(),
                        "address": address
                    };
                }
            });
        },
        get_total_price_with_markup(travelerPricings) {
            return getTotalPriceWithMarkup(travelerPricings, this.max_ticket_price);
        },
        payment_method_change() {
            this.is_payment_loading = 1;
            $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
            var body = {
                guest_id: this.guest_data.guest.id,
                payment_method: this.payment_method,
                amount: parseFloat(this.amount_due).toFixed(2),
                subject: 'flight',
            };
            paymentService.prepare_the_checkout(body).then((response) => {
                this.checkoutId = response.data.checkoutId;
                this.payment_redirect_url = window.location.origin + '/flight-confirmation/';
                let recaptchaScript = document.createElement('script');
                recaptchaScript.setAttribute('src', `${process.env.VUE_APP_FLIGHT_MODE == 'live' ? 'https://eu-prod.oppwa.com' : 'https://eu-test.oppwa.com'}/v1/paymentWidgets.js?checkoutId=` + this.checkoutId);
                recaptchaScript.setAttribute('strategy', 'afterInteractive');
                document.head.appendChild(recaptchaScript);
                recaptchaScript.onload = () => {
                    setTimeout(() => {
                        $('.wpwl-control-brand').children('option').each(function () {
                            $(this).html(that.$t($(this).text()));
                        });

                        $(document).find('.wpwl-label-cardNumber').html(this.$t('Card Number'));
                        $(document).find('[name="card.number"]').attr('placeholder', this.$t('Card Number'));

                        if (that.$i18n.locale === 'ar') {
                            $(document).find('[name="card.number"]').css('direction', 'ltr');
                            $(document).find('[name="card.number"]').css('text-align', 'right');
                        }

                        $(document).find('.wpwl-label-expiry').html(this.$t('Expiry Date'));
                        $(document).find('.wpwl-control-expiry').attr('placeholder', this.$t('MM / YY'));

                        $(document).find('.wpwl-label-cvv').html(this.$t('CVV'));
                        $(document).find('[name="card.cvv"]').attr('placeholder', this.$t('CVV'));

                        $(document).find('.wpwl-label-cardHolder').html(this.$t('Card holder'));
                        $(document).find('.wpwl-control-cardHolder').attr('placeholder', this.$t('Card holder'));

                        $(document).find('.wpwl-button-pay').html(this.$t('Pay now'));
                        that.is_payment_loading = 0;
                        $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
                    }, 100);
                }
            });
        },
        formattedDate(date) {
            const parts = date.split('/');
            return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
        },
        formattedDateRange(startDate, endDate) {
            return formattedDateRange(startDate, endDate, this.$i18n.locale);
        },
        date_format(date) {
            return frCaDateFormat(date);
        },
        add_days_to_date(date, days) {
            return addDaysToDate(date, days);
        },
        decrease_day_from_date(date) {
            return decreaseDayFromDate(date);
        },
        need_an_extra_day_at_beginning(date, time, time_allowed_entry_before_booking) {
            return needAnExtraDayAtBeginning(date, time, time_allowed_entry_before_booking);
        },
        need_an_extra_day_at_end(date1, date2) {
            return needAnExtraDayAtEnd(date1, date2);
        },
        count_extra_day_at_end(date1, date2) {
            return countExtraDayAtEnd(date1, date2);
        },
        changeEntry(date) {
            const dateStr1 = date;
            const dateStr2 = this.entry_date;
            const date1 = new Date(dateStr1);
            const date2 = new Date(dateStr2);
            if (date1 < date2 || date1 > date2) {
                setTimeout(() => {
                    $(document).find('.dp__action_select').click();
                }, 50);
            }
            if (this.is_self_paying == 1) {
                this.arrival_time_to_riyadh = this.entry_date;
                this.entry_hotel_date = this.date_format(this.arrival_time_to_riyadh);
                this.exit_hotel_date = this.date_format(this.departure_time_for_riyadh);
            } else {
                if (this.entry_date) {
                    this.arrival_time_to_riyadh = this.entry_date;
                    this.entry_hotel_date = this.date_format(this.arrival_time_to_riyadh);
                    this.exit_hotel_date = this.add_days_to_date(this.formatDateSafari(this.entry_hotel_date), this.hotel_conditions.free_duration);
                    if (this.exit_hotel_date > this.departure_time_for_riyadh) {
                        this.exit_hotel_date = this.date_format(this.departure_time_for_riyadh);
                    }
                    this.need_extra_end = this.need_an_extra_day_at_end(this.exit_hotel_date, new Date(this.departure_time_for_riyadh).toLocaleDateString('sv-SE'));
                    if (this.need_extra_end) {
                        this.count_extra_end = this.count_extra_day_at_end(this.exit_hotel_date, new Date(this.departure_time_for_riyadh).toLocaleDateString('sv-SE'));
                        this.end_extra_date = this.add_days_to_date(this.formatDateSafari(this.exit_hotel_date), this.count_extra_end);
                    }
                }
            }
        },
        changeHotel() {
            this.need_assistance = '';
            this.confirm = null;
            this.current_hotel = this.hotels.filter(item => {
                return item.id == this.hotel_id;
            })[0];

            var room_prices = this.current_hotel.room_prices;
            if (room_prices) {
                var room_type = this.guest_data.policy.room_type.toLowerCase();
                if (this.passengers.length == 1) {
                    this.room_price = room_prices[room_type + '_sale_price']
                } else {
                    this.room_price = room_prices[room_type + '_sale_price_with_companion'];
                }
            }

            if (this.current_hotel?.images?.length > 0) {
                this.hotel_img = `${this.saudi_cup_url}/storage` + this.current_hotel.images[0].image;
            } else {
                this.hotel_img = null;
            }
            var time_allowed_entry_before_booking = this.current_hotel.allow_check_in_before_time;
            var need_extra = this.need_an_extra_day_at_beginning(new Date(this.arrival_time_to_riyadh), this.current_hotel.check_in_time, time_allowed_entry_before_booking);
            var free_duration = this.hotel_conditions.free_duration;
            if (need_extra) {
                this.entry_hotel_date = this.decrease_day_from_date(this.arrival_time_to_riyadh);
                free_duration = parseInt(free_duration) + 1;
            } else {
                this.entry_hotel_date = this.date_format(this.arrival_time_to_riyadh);
            }
            this.exit_hotel_date = this.add_days_to_date(this.formatDateSafari(this.entry_hotel_date), free_duration);
            if (this.exit_hotel_date > this.departure_time_for_riyadh) {
                this.exit_hotel_date = this.date_format(this.departure_time_for_riyadh);
            }
            this.need_extra_end = this.need_an_extra_day_at_end(this.exit_hotel_date, new Date(this.departure_time_for_riyadh).toLocaleDateString('sv-SE'));

            if (this.tripType == 'oneway') {
                this.exit_hotel_date = null;
                this.entry_hotel_date = null;
                this.need_extra_end = false;
                this.entry_date = null;
            }
            if (this.need_extra_end) {
                this.count_extra_end = this.count_extra_day_at_end(this.exit_hotel_date, new Date(this.departure_time_for_riyadh).toLocaleDateString('sv-SE'));
                this.end_extra_date = this.add_days_to_date(this.formatDateSafari(this.exit_hotel_date), this.count_extra_end);
            }
        },
        convertDuration(duration) {
            return convertDuration(duration);
        },
        getCountriesByCode(code) {
            var info = countriesData.filter(item => {
                return item.en_label.includes(code);
            });
            return info[0];
        },
        async send() {
            var forms = document.querySelectorAll('.needs-validation')
            if (forms.length > 0) {
                forms[0].classList.add('was-validated');
                if (!forms[0].checkValidity()) {
                    toast.error(this.$t('All fields are required'), {
                        autoClose: 3500,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
                    return;
                }
            }

            $('.pre-loader').show();

            var arrival_flight = JSON.parse(localStorage.getItem("arrival_flight"));
            var departure_flight = JSON.parse(localStorage.getItem("departure_flight"));
            var passengers_details = JSON.parse(localStorage.getItem("passengersDetails"));
            var guest_id = localStorage.getItem("guest_id");
            var group_id = localStorage.getItem("group_id");
            var user_token = localStorage.getItem("user_token");
            var order_type = localStorage.getItem("order_type");
            var trip_type = localStorage.getItem("tripType");
            var sector = '';
            var from = [];
            var to = [];
            var date = [];


            if (trip_type == 'multi_city') {
                const params = new URLSearchParams(this.searchData.info);
                from = params.getAll('from[]');
                to = params.getAll('to[]');
                date = params.getAll('date[]');
                sector = from[0] + '/' + to[0] + '/' + from[1] + '/' + to[1];
            } else if (trip_type == 'oneway') {
                sector = this.searchData.from + '/' + this.searchData.to;
            } else {
                sector = this.searchData.from + '/' + this.searchData.to + '/' + this.searchData.from;
            }

            const companion_guest_id = this.sp_can_book_hotel ? passengers_details.filter((element) => element.id !== this.guest_data.guest.id).find(() => true) : null;

            var hotel_body = {
                is_need_booking: this.is_need_booking,
                hotel_id: this.hotel_id,
                "guests[0]": this.guest_data?.guest?.id,
                on_his_expense: this.is_self_paying,
                start_date: this.entry_hotel_date,
                end_date: this.exit_hotel_date,
                type: this.guest_data.policy.room_type,
                bed_type: this.room_type,
                self_paying_description: this.sp_can_book_hotel
                    ? JSON.stringify({
                        text: `I want to book (${this.count_extra_day_at_end(this.entry_hotel_date, this.exit_hotel_date)}) nights at ${this.current_hotel.en_name} hotel, from ${this.entry_hotel_date} to ${this.exit_hotel_date}, with ${this.room_type}`,
                        variables: {
                            nights: `${this.count_extra_day_at_end(this.entry_hotel_date, this.exit_hotel_date)}`,
                            hotel_name: this.current_hotel.en_name,
                            start_date: this.entry_hotel_date,
                            end_date: this.exit_hotel_date,
                            type: this.room_type,
                            main_guest_id: this.stay_with_friend == '1' ? this.main_guest_id : null,
                            companion_guest_id: companion_guest_id ? companion_guest_id.id : null
                        }
                    })
                    : {},
                extra_nights: this.need_assistance == 1 ? "i want " + this.count_extra_end + " extra nights from " + this.exit_hotel_date + " to " + this.end_extra_date + " and room type is (" + this.extra_room_type + ")" : null
            };

            if (this.is_need_booking == '0') {
                hotel_body = {
                    is_need_booking: this.is_need_booking,
                    "guests[0]": this.guest_data?.guest?.id,
                    on_his_expense: this.is_self_paying,
                    hotel_reference: this.hotel_reference,
                    extra_nights: null,
                    self_paying_description: this.sp_can_book_hotel
                        ? JSON.stringify({
                            text: `I want to book (${this.count_extra_day_at_end(this.entry_hotel_date, this.exit_hotel_date)}) nights at ${this.current_hotel.en_name} hotel, from ${this.entry_hotel_date} to ${this.exit_hotel_date}, with ${this.room_type}`,
                            variables: {
                                nights: `${this.count_extra_day_at_end(this.entry_hotel_date, this.exit_hotel_date)}`,
                                hotel_name: this.current_hotel.en_name,
                                start_date: this.entry_hotel_date,
                                end_date: this.exit_hotel_date,
                                type: this.room_type,
                                main_guest_id: this.stay_with_friend == '1' ? this.main_guest_id : null,
                                companion_guest_id: companion_guest_id ? companion_guest_id.id : null
                            }
                        })
                        : {},
                };
            } else if (this.is_need_booking == '2') {
                hotel_body = {
                    service_id: 4,
                    service_type: "Additional Service",
                    service_status: "In Progress",
                    "attachments[Check in Date]": trip_type != 'oneway' ? this.entry_hotel_date : new Date(this.entry_date).toLocaleDateString('sv-SE'),
                    "attachments[Check out Date]": new Date(this.departure_time_for_riyadh).toLocaleDateString('sv-SE'),
                    "guests[0]": this.guest_data?.guest?.id,
                };
            }

            var travelers = [];
            passengers_details.forEach((element, index) => {
                const issuing_country = this.getCountriesByCode(element.passport_issuing_country);
                travelers.push({
                    "id": index + 1,
                    "LoyaltyProgram": element.LoyaltyProgram,
                    "dateOfBirth": element.birthday,
                    "name": {
                        "firstName": element.first_name,
                        "lastName": element.last_name,
                    },
                    "gender": (element.title == "mr" ? 'MALE' : 'FEMALE'),
                    "contact": {
                        "emailAddress": element.email,
                        "phones": [
                            {
                                "deviceType": "MOBILE",
                                "countryCallingCode": "966",
                                "number": "555656586"
                            }
                        ]
                    },
                    "emergencyContact": {
                        "addresseeName": "riyadh",
                        "countryCode": "SA",
                        "number": '966555656586',
                        "text": element.registration_number,
                    },
                    "documents": [
                        {
                            "documentType": "PASSPORT",
                            "birthPlace": element.nationality,
                            "issuanceLocation": element.passport_issuing_country,
                            "issuanceDate": element.passport_issue_date,
                            "number": element.passport_number,
                            "expiryDate": element.passport_expiry_date,
                            "issuanceCountry": issuing_country['value'],
                            "validityCountry": issuing_country['value'],
                            "nationality": issuing_country['value'],
                            "holder": true
                        }
                    ]
                });
                if (group_id != null || this.is_need_booking == '2') {
                    hotel_body[`guests[${index}]`] = element.id;
                }
            });

            var flight_order =
            {
                data: {
                    type: "flight-order",
                    queuingOfficeId: "RUHS228ZQ",
                    flightOffers: this.flightOffers,
                    travelers: travelers,
                    remarks: {
                        general: [
                            {
                                subType: "GENERAL_MISCELLANEOUS",
                                text: "FLY-AAA-2558"
                            }
                        ]
                    },
                    automatedProcess: [
                        {
                            code: "IMMEDIATE",
                            queue: {
                                number: "7",
                                category: "2"
                            },
                            officeId: "RUHS228ZQ"
                        }
                    ],
                    formOfPayments: [
                        {
                            other: {
                                method: "CASH",
                                flightOfferIds: [
                                    this.flightOffers[0].id
                                ]
                            }
                        }
                    ],
                    ticketingAgreement: {
                        option: "DELAY_TO_CANCEL",
                        delay: "7D"
                    },
                }
            };

            var body = {
                flight_order: flight_order,
                adult: this.searchData.adults,
                children: this.searchData.children,
                infant: this.searchData.infants,
                cabin: this.searchData.cabin,
                from: trip_type != 'multi_city' ? this.searchData.from : from[0],
                to: trip_type != 'multi_city' ? this.searchData.to : to[0],
                departure_date: trip_type != 'multi_city' ? this.searchData.date : date[0],
                return_date: trip_type != 'multi_city' ? this.searchData.ret_date : date[1],
                trip_type: trip_type,
                is_request: order_type == 'order' || parseInt(localStorage.getItem("need_approval")) == 1 ? 1 : 0,
                passengers: JSON.parse(localStorage.getItem("passengers")),
                passengers_details: passengers_details,
                guest_data: this.guest_data,
                guest_id: guest_id,
                user_token: user_token,
                hotel_body: ((this.is_self_paying == 0 && this.essential_guest == 1) || this.sp_can_book_hotel) ? hotel_body : null,
                sector: sector,
                is_self_paying: this.is_self_paying,
                markup: parseFloat(this.markup).toFixed(2),
                source: 'web',
                theme: this.theme,
                departure_period: convertDuration(departure_flight.itineraries[0].duration, 'en'),
                return_period: trip_type != 'oneway' ?
                    convertDuration(trip_type == 'multi_city' ?
                        departure_flight.itineraries[1].duration
                        :
                        arrival_flight.itineraries[1].duration, 'en'
                    ) : null,
            };

            var passengers_id = [];
            passengers_details.forEach(element => {
                passengers_id.push(element.id);
            });

            var body_request = {
                passengers: JSON.stringify(passengers_id),
                type_of_flight: trip_type,
                amount: parseFloat(this.total).toFixed(2),
                guest_id: this.guest_data?.guest?.id,
                departure_from_airport: trip_type != 'multi_city' ? this.searchData.from : from[0],
                departure_to_airport: trip_type != 'multi_city' ? this.searchData.to : to[0],
                departure_date: trip_type != 'multi_city' ? this.searchData.date : date[0],
                departure_time: formatTime(this.flightOffers[0].itineraries[0].segments[0].departure.at),
                departure_arrival_time: formatTime(this.flightOffers[0].itineraries[0].segments[this.flightOffers[0].itineraries[0].segments.length - 1].arrival.at),
                booking_degree: this.searchData.cabin,
                return_from_airport: trip_type != 'multi_city' ? this.searchData.to : to[0],
                return_to_airport: trip_type != 'multi_city' ? this.searchData.from : from[0],
                return_date: trip_type != 'multi_city' ? this.searchData.ret_date : date[1],
                return_time: trip_type != 'oneway' ? formatTime(this.flightOffers[0].itineraries[1].segments[0].departure.at) : null,
                return_arrival_time: trip_type != 'oneway' ? formatTime(this.flightOffers[0].itineraries[1].segments[this.flightOffers[0].itineraries[1].segments.length - 1].arrival.at) : null,
                flight_company_name: this.flightOffers[0].validatingAirlineCodes[0],
            };
            await flightsService.flight_offers_send_order(body).then((response) => {
                this.show_send_btn = false;

                $('.pre-loader').hide();
                toast.success(this.$t('Your reservation was completed successfully'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });

                setTimeout(() => {
                    localStorage.clear();
                    window.location = this.redirect_url;
                }, 2000);
            }).catch(error => {
                if (this.is_self_paying == 0) {
                    $('.pre-loader').hide();
                    this.show_send_btn = false;
                    toast.error(this.$t('An error occurred during the booking process'), {
                        autoClose: 3500,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
                } else {
                    this.store_self_paying_airline(body_request);
                }
            });
        },
        async store_self_paying_airline(body) {
            await airlineService.send_self_paying_request(body).then((response) => {
                $('.pre-loader').hide();
                this.show_send_btn = false;
                toast.success(this.$t('Your reservation request has been sent successfully'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
                setTimeout(() => {
                    localStorage.clear();
                    window.location = this.redirect_url;
                }, 2000);
            });
        },
        getCoordinates(data, code) {
            const location = data.find(item => item.code.includes(code));
            return { lat: location.lat, lng: location.lng };
        },
        buildMarkers(data, segments) {
            let markers = '', path = '';
            segments.forEach(segment => {
                const depCoords = this.getCoordinates(data, segment.departure.iataCode);
                const arrCoords = this.getCoordinates(data, segment.arrival.iataCode);
                markers += ` &markers=color:red|${depCoords.lat},${depCoords.lng}`;
                markers += ` &markers=color:red|${arrCoords.lat},${arrCoords.lng}`;
                path += `|${depCoords.lat},${depCoords.lng}|${arrCoords.lat},${arrCoords.lng}`;
            });
            return { markers, path };
        },
        generateMapUrl(centerLat, centerLng, size, markers, path, pathColor) {
            return `https://maps.google.com/maps/api/staticmap?
            center=${centerLat},${centerLng}
            &type=terrain
            &size=600x250
            &key=AIzaSyCU_-f44KpO2Mhupb-qWLQY-bp0_tQaUzs
            ${markers}
            &path=color:${pathColor}|weight:4|geodesic:true${path}
            &sensor=false
            &region=${this.$i18n.locale}`;
        },
        async flight_offers_pricing(flightOffers) {
            localStorage.removeItem('detailed_fare_rules');
            var body = {
                flight: {
                    data: {
                        type: "flight-offers-pricing",
                        flightOffers: [
                            flightOffers
                        ]
                    }
                }
            };
            await flightsService.flight_offers_pricing(body).then(async (response) => {
                var res = response.data.data;
                this.flightOffers = res.data.flightOffers;

                if (this.is_self_paying && this.is_bags_confirmed) {
                    this.flightOffers = JSON.parse(localStorage.getItem("flightOffers"));
                }

                if (res.included?.hasOwnProperty('detailed-fare-rules')) {
                    localStorage.setItem('detailed_fare_rules', JSON.stringify(res.included['detailed-fare-rules']));
                }

                if (res.included?.hasOwnProperty('bags') && this.allowed_to_request_additional_weight == '1') {
                    this.bags = res.included['bags'];
                    this.bags_price = res.included['bags'];

                    const dataList = Object.entries(this.bags).map(([id, value]) => ({ id, ...value }));
                    const groupedBaggage = dataList.reduce((acc, item) => {
                        const key = JSON.stringify(item.segmentIds);
                        if (!acc[key]) {
                            acc[key] = {
                                segmentIds: item.segmentIds,
                                baggage: [],
                            };
                        }
                        acc[key].baggage.push(item);
                        return acc;
                    }, {});
                    const result = Object.values(groupedBaggage);
                    const resultCopy = JSON.parse(JSON.stringify(result));
                    const itineraries = this.flightOffers[0].itineraries;
                    const departureSegmentIds = itineraries[0]?.segments.map(segment => segment.id) || [];
                    const returnSegmentIds = itineraries[1]?.segments.map(segment => segment.id) || [];

                    const departureBaggage = result.map(item => ({
                        ...item,
                        segmentIds: item.segmentIds.filter(id => departureSegmentIds.includes(id)),
                    })).filter(item => item.segmentIds.length > 0);

                    const returnBaggage = resultCopy.map(item => ({
                        ...item,
                        segmentIds: item.segmentIds.filter(id => returnSegmentIds.includes(id)),
                    })).filter(item => item.segmentIds.length > 0);


                    departureBaggage[0].baggage.forEach(element => {
                        element['segmentIds'] = [...departureBaggage[0].segmentIds];
                    });

                    returnBaggage[0].baggage.forEach(element => {
                        element['segmentIds'] = [...returnBaggage[0].segmentIds];
                    });

                    if (!this.is_bags_confirmed) {
                        this.bags = [departureBaggage[0], returnBaggage[0]];
                        localStorage.setItem('bags', JSON.stringify(this.bags));

                        this.departure_selected_bags = Array(this.passengers.length).fill('');
                        this.arrival_selected_bags = Array(this.passengers.length).fill('');
                    } else {
                        this.bags = JSON.parse(localStorage.getItem("bags"));
                        this.departure_selected_bags = JSON.parse(localStorage.getItem("departure_selected_bags"));
                        this.arrival_selected_bags = JSON.parse(localStorage.getItem("arrival_selected_bags"));
                    }
                }
                this.total = this.get_total_price_with_markup(this.flightOffers[0].travelerPricings);


                if (this.is_self_paying == 1) {
                    this.total_amount = this.total;
                    await guestService.get_guest_package(this.guest_data['guest']['registration_number']).then((response) => {
                        var data = response.data.data;
                        data.forEach(element => {
                            this.total_amount += parseFloat(element.price);
                        });
                        this.guest_packages = data.filter(element => element.service.service_name_en != 'Hotels');
                        this.sp_can_book_hotel = data.some(element => element.service.service_name_en === 'Hotels');
                    });
                    this.discount = (parseFloat(this.guest_packages[0].package.discount) / 100) * this.total_amount;
                    this.amount_due = this.total_amount - this.discount;

                    if (this.need_payment == 1) {
                        var checkoutId = this.$route.params.checkoutId;
                        var is_package_confirmed = localStorage.getItem('is_package_confirmed');
                        if (checkoutId) {
                            await paymentService.check_payment_result(checkoutId).then((response) => {
                                if (response.data.status == "Transaction succeeded") {
                                    this.need_payment = 0;
                                    var data = {
                                        guest_package_services_id: [
                                            this.guest_packages
                                                .filter(
                                                    element => element.service.service_name_en == 'Flights')[0].id
                                        ],
                                        guest_package_services_price: [this.total],
                                        guest_package_services_tickets_num: [1]
                                    };
                                    if (is_package_confirmed != '1') {
                                        guestService.confirm_guest_package(data).then((response) => {
                                            localStorage.setItem('is_package_confirmed', 1);
                                            toast.success(this.$t('The payment was completed successfully'), {
                                                autoClose: 5000,
                                                position: toast.POSITION.TOP_CENTER,
                                                closeButton: false
                                            });
                                            $('.pre-loader').hide();
                                            $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
                                        });
                                    } else {
                                        $('.pre-loader').hide();
                                        $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
                                    }
                                } else {
                                    $('.pre-loader').hide();
                                    this.need_payment = 1;
                                    toast.error(this.$t('Payment failed'), {
                                        autoClose: 5000,
                                        position: toast.POSITION.TOP_CENTER,
                                        closeButton: false
                                    });
                                }
                            }).catch(error => {
                                $('.pre-loader').hide();
                                toast.error(this.$t('checkout Id is not correct'), {
                                    autoClose: 5000,
                                    position: toast.POSITION.TOP_CENTER,
                                    closeButton: false
                                });
                            });
                        } else {
                            $('.pre-loader').hide();
                        }
                    } else {
                        $('.pre-loader').hide();
                    }
                } else {
                    $('.pre-loader').hide();
                }
                if (this.allow_sitemap == '1') {
                    var body = {
                        data: [this.flightOffers[0]]
                    };
                    await flightsService.flight_offers_seatmaps(body).then(async (response) => {
                        this.seatData = response.data.data;
                        this.seatmap = response.data.data.data;
                        this.select_passenger(1, this.seatmap[0].segmentId);
                    }).catch(error => {
                        console.log(error);
                    });
                }
            }).catch(error => {
                console.log(error);
                $('.pre-loader').hide();
                this.show_send_btn = false;
                this.show_payment_form = false;
                toast.error(this.$t('A problem occurred during the pricing process'), {
                    autoClose: 5000,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
            });
        },
        async flight_offers_pricing_with_bags(flightOffers) {
            var body = {
                flight: {
                    data: {
                        type: "flight-offers-pricing",
                        flightOffers: [
                            flightOffers
                        ]
                    }
                }
            };
            await flightsService.flight_offers_pricing(body).then(async (response) => {
                var res = response.data.data;
                this.flightOffers = res.data.flightOffers;
                this.total = this.get_total_price_with_markup(this.flightOffers[0].travelerPricings);

                if (this.is_self_paying == 1) {
                    this.total_amount = this.total;
                    await guestService.get_guest_package(this.guest_data['guest']['registration_number']).then((response) => {
                        var data = response.data.data;
                        data.forEach(element => {
                            this.total_amount += parseFloat(element.price);
                        });
                        this.guest_packages = data.filter(element => element.service.service_name_en != 'Hotels');
                        this.sp_can_book_hotel = data.some(element => element.service.service_name_en === 'Hotels');
                    });
                    this.discount = (parseFloat(this.guest_packages[0].package.discount) / 100) * this.total_amount;
                    this.amount_due = this.total_amount - this.discount;
                    $('.pre-loader').hide();
                } else {
                    $('.pre-loader').hide();
                }
                localStorage.setItem("flightOffers", JSON.stringify(this.flightOffers));
            }).catch(error => {
                console.log(error);
                $('.pre-loader').hide();
                this.show_send_btn = false;
                this.show_payment_form = false;
                toast.error(this.$t('A problem occurred during the pricing process'), {
                    autoClose: 5000,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
            });
        },
        get_hotel_booking_date() {
            var records = [];
            const [arrival, arrival_time] = this.arrival_time_to_riyadh.split("T");
            const [departure, departure_time] = this.departure_time_for_riyadh.split("T");
            records.push({
                arrival: arrival,
                arrival_time: arrival_time,
                departure: departure,
                departure_time: departure_time,
            });
            this.guest_data.guest.companions.forEach(element => {
                if (element.flight) {
                    records.push({
                        arrival: element.flight.arrival_date,
                        arrival_time: element.flight.arrival_time,
                        departure: element.flight.return_date,
                        departure_time: element.flight.return_time,
                    });
                }
            });

            const parseDateTime = (date, time) => `${date}T${time}`;
            let earliestArrival = parseDateTime(records[0].arrival, records[0].arrival_time);
            let latestDeparture = parseDateTime(records[0].departure, records[0].departure_time);
            for (const record of records) {
                const arrivalDateTime = parseDateTime(record.arrival, record.arrival_time);
                const departureDateTime = parseDateTime(record.departure, record.departure_time);
                if (arrivalDateTime < earliestArrival) {
                    earliestArrival = arrivalDateTime;
                    this.show_hotel_note = true;
                }
                if (departureDateTime > latestDeparture) {
                    latestDeparture = departureDateTime;
                    this.show_hotel_note = true;
                }
            }
            return { latestDeparture, earliestArrival }
        }
    },
    mounted() {
        document.addEventListener('click', function (event) {
            if (event.target.classList.contains('drawer-bar-item')) {
                const id = event.target.getAttribute('data-id');
                document.querySelectorAll('.drawer-bar-item').forEach(function (item) {
                    item.classList.remove('active');
                });
                event.target.classList.add('active');
                document.querySelectorAll('.drawer-container').forEach(function (container) {
                    container.style.display = 'none';
                });
                const targetContainer = document.querySelector(id);
                if (targetContainer) {
                    targetContainer.style.display = 'block';
                }
            }
        });
        that = this;
        var group_id = localStorage.getItem("group_id");
        this.airlines = airlinesData;
        this.redirect_url = localStorage.getItem("redirect_url");
        this.guest_data = JSON.parse(localStorage.getItem("guest_data"));
        this.policy = this.guest_data.policy;
        this.is_self_paying = localStorage.getItem("is_self_paying");
        this.need_payment = localStorage.getItem("is_self_paying");
        this.essential_guest = localStorage.getItem("essential_guest");
        this.passengers = JSON.parse(localStorage.getItem("passengersDetails"));
        this.searchData = JSON.parse(localStorage.getItem("searchData"));
        this.departure_flight = JSON.parse(localStorage.getItem("departure_flight"));
        this.arrival_flight = JSON.parse(localStorage.getItem("arrival_flight"));
        this.tripType = localStorage.getItem("tripType");
        this.max_ticket_price = localStorage.getItem("max_price");
        this.allowed_to_request_hotel_reservation = localStorage.getItem("allowed_to_request_hotel_reservation");
        this.allowed_to_request_additional_weight = localStorage.getItem("allowed_to_request_additional_weight");
        // this.allow_sitemap = localStorage.getItem("allow_sitemap");
        this.theme = localStorage.getItem('theme')

        if (this.$route.params.checkoutId) {
            this.is_bags_confirmed = Boolean(localStorage.getItem("is_bags_confirmed"));
        } else {
            this.is_bags_confirmed = false;
        }

        $('.pre-loader').show();

        if (!this.searchData) {
            window.location = '/erorr';
        }
        if (this.tripType == 'oneway') {
            const departureSegments = this.departure_flight.itineraries[0].segments;
            const departureCoords = this.getCoordinates(jsonDataEn, this.searchData.to);
            const arrivalCoords = this.getCoordinates(jsonDataEn, this.searchData.from);

            const { markers, path } = this.buildMarkers(jsonDataEn, departureSegments);
            const centerLat = (parseFloat(departureCoords.lat) + parseFloat(arrivalCoords.lat)) / 2;
            const centerLng = (parseFloat(departureCoords.lng) + parseFloat(arrivalCoords.lng)) / 2;
            this.getOutboundImg = this.generateMapUrl(centerLat, centerLng, departureSegments.length === 1 ? 350 : departureSegments.length * 200, markers, path, '0xd1b26e');
            this.departure_time_for_riyadh = this.departure_flight.itineraries[0].segments[0].departure.at;
            if (group_id == null) {
                const { latestDeparture, earliestArrival } = this.get_hotel_booking_date();
                this.departure_time_for_riyadh = latestDeparture;
            }
        } else if (this.tripType == 'roundtrip') {
            const departureSegments = this.departure_flight.itineraries[0].segments;
            const returnSegments = this.departure_flight.itineraries[1].segments;

            // Outbound map
            const outboundDepartureCoords = this.getCoordinates(jsonDataEn, this.searchData.from);
            const outboundArrivalCoords = this.getCoordinates(jsonDataEn, this.searchData.to);
            const outboundData = this.buildMarkers(jsonDataEn, departureSegments);
            const outboundCenterLat = (parseFloat(outboundDepartureCoords.lat) + parseFloat(outboundArrivalCoords.lat)) / 2;
            const outboundCenterLng = (parseFloat(outboundDepartureCoords.lng) + parseFloat(outboundArrivalCoords.lng)) / 2;
            this.getOutboundImg = this.generateMapUrl(outboundCenterLat, outboundCenterLng, departureSegments.length === 1 ? 350 : departureSegments.length * 200, outboundData.markers, outboundData.path, '0xd1b26e');

            // Inbound map
            const inboundDepartureCoords = this.getCoordinates(jsonDataEn, this.searchData.to);
            const inboundArrivalCoords = this.getCoordinates(jsonDataEn, this.searchData.from);
            const inboundData = this.buildMarkers(jsonDataEn, returnSegments);
            const inboundCenterLat = (parseFloat(inboundDepartureCoords.lat) + parseFloat(inboundArrivalCoords.lat)) / 2;
            const inboundCenterLng = (parseFloat(inboundDepartureCoords.lng) + parseFloat(inboundArrivalCoords.lng)) / 2;
            this.getInboundImg = this.generateMapUrl(inboundCenterLat, inboundCenterLng, returnSegments.length === 1 ? 350 : returnSegments.length * 200, inboundData.markers, inboundData.path, '0xd1b26e');

            this.arrival_time_to_riyadh = this.departure_flight.itineraries[0].segments[this.departure_flight.itineraries[0].segments.length - 1].arrival.at;
            this.departure_time_for_riyadh = this.arrival_flight.itineraries[1].segments[0].departure.at;

            if (group_id == null) {
                const { latestDeparture, earliestArrival } = this.get_hotel_booking_date();
                this.arrival_time_to_riyadh = earliestArrival;
                this.departure_time_for_riyadh = latestDeparture;
            }
        } else {
            const params = new URLSearchParams(this.searchData.info);
            this.from = params.getAll('from[]');
            this.to = params.getAll('to[]');
            this.date = params.getAll('date[]');
            const departureSegments = this.departure_flight.itineraries[0].segments;
            const returnSegments = this.departure_flight.itineraries[1].segments;

            // Outbound map
            const outboundDepartureCoords = this.getCoordinates(jsonDataEn, this.from[0]);
            const outboundArrivalCoords = this.getCoordinates(jsonDataEn, this.to[0]);
            const outboundData = this.buildMarkers(jsonDataEn, departureSegments);
            const outboundCenterLat = (parseFloat(outboundDepartureCoords.lat) + parseFloat(outboundArrivalCoords.lat)) / 2;
            const outboundCenterLng = (parseFloat(outboundDepartureCoords.lng) + parseFloat(outboundArrivalCoords.lng)) / 2;
            this.getOutboundImg = this.generateMapUrl(outboundCenterLat, outboundCenterLng, departureSegments.length === 1 ? 350 : departureSegments.length * 200, outboundData.markers, outboundData.path, '0xd1b26e');

            // Inbound map
            const inboundDepartureCoords = this.getCoordinates(jsonDataEn, this.to[1]);
            const inboundArrivalCoords = this.getCoordinates(jsonDataEn, this.from[1]);
            const inboundData = this.buildMarkers(jsonDataEn, returnSegments);
            const inboundCenterLat = (parseFloat(inboundDepartureCoords.lat) + parseFloat(inboundArrivalCoords.lat)) / 2;
            const inboundCenterLng = (parseFloat(inboundDepartureCoords.lng) + parseFloat(inboundArrivalCoords.lng)) / 2;
            this.getInboundImg = this.generateMapUrl(inboundCenterLat, inboundCenterLng, returnSegments.length === 1 ? 350 : returnSegments.length * 200, inboundData.markers, inboundData.path, '0xd1b26e');

            this.arrival_time_to_riyadh = this.departure_flight.itineraries[0].segments[this.departure_flight.itineraries[0].segments.length - 1].arrival.at;
            this.departure_time_for_riyadh = this.departure_flight.itineraries[1].segments[0].departure.at;

            if (group_id == null) {
                const { latestDeparture, earliestArrival } = this.get_hotel_booking_date();
                this.arrival_time_to_riyadh = earliestArrival;
                this.departure_time_for_riyadh = latestDeparture;
            }
        }

        this.hotel_conditions = {
            reservation_start_date: new Date(this.arrival_time_to_riyadh).toLocaleDateString('sv-SE'),
            reservation_end_date: new Date(this.departure_time_for_riyadh).toLocaleDateString('sv-SE'),
            free_reservation_start_date: this.guest_data.policy.free_entry_date_to_the_hotel,
            free_reservation_end_date: this.guest_data.policy.free_check_out_date_from_the_hotel,
            free_duration: this.guest_data.policy.number_of_free_nights,
        };

        var arrival_flight = JSON.parse(localStorage.getItem("arrival_flight")),
            departure_flight = JSON.parse(localStorage.getItem("departure_flight"));
        if (this.tripType == 'roundtrip') {
            var arrival_segments_id = [], departure_segments_id = [];
            var arrival_segments = arrival_flight.itineraries[1].segments;
            arrival_segments.forEach(element => {
                arrival_segments_id.push(element.id)
            });
            var departure_segments = departure_flight.itineraries[0].segments;
            departure_segments.forEach(element => {
                departure_segments_id.push(element.id)
            });
            for (let index = 0; index < this.passengers.length; index++) {
                departure_flight.travelerPricings[index].fareDetailsBySegment = departure_flight.travelerPricings[index].fareDetailsBySegment.filter(item => {
                    return departure_segments_id.includes(item.segmentId);
                });
                var arrival_flights_segment = arrival_flight.travelerPricings[index].fareDetailsBySegment.filter(item => {
                    return arrival_segments_id.includes(item.segmentId);
                })
                arrival_flights_segment.forEach(element => {
                    departure_flight.travelerPricings[index].fareDetailsBySegment.push(element);
                });
            }
            departure_flight.itineraries = [departure_flight.itineraries[0], arrival_flight.itineraries[1]];
        }

        this.flight_offers_pricing(departure_flight);

        if (this.allowed_to_request_hotel_reservation == 1 || this.sp_can_book_hotel) {
            this.guest_data.policy.hotels.forEach(element => {
                this.hotels.push(element.hotel);
            });
            this.current_hotel = this.hotels[0];
            this.hotel_id = this.current_hotel.id;

            var room_prices = this.current_hotel.room_prices;
            if (room_prices) {
                var room_type = this.guest_data.policy.room_type.toLowerCase();
                if (this.passengers.length == 1) {
                    this.room_price = room_prices[room_type + '_sale_price']
                } else {
                    this.room_price = room_prices[room_type + '_sale_price_with_companion'];
                }
            }

            if (this.current_hotel?.images?.length > 0) {
                this.hotel_img = `${this.saudi_cup_url}/storage` + this.current_hotel.images[0].image;
            } else {
                this.hotel_img = null;
            }
            var time_allowed_entry_before_booking = this.current_hotel.allow_check_in_before_time;
            if (this.is_self_paying == 1) {
                this.need_start_extra = this.need_an_extra_day_at_beginning(new Date(this.arrival_time_to_riyadh), this.current_hotel.check_in_time, parseFloat(time_allowed_entry_before_booking));
                if (this.need_start_extra) {
                    this.entry_hotel_date = this.decrease_day_from_date(this.arrival_time_to_riyadh);
                } else {
                    this.entry_hotel_date = this.date_format(this.arrival_time_to_riyadh);
                }
                this.exit_hotel_date = this.date_format(this.departure_time_for_riyadh);
                if (this.tripType == 'oneway') {
                    this.exit_hotel_date = null;
                    this.entry_hotel_date = null;
                }
            } else {
                var need_extra = this.need_an_extra_day_at_beginning(new Date(this.arrival_time_to_riyadh), this.current_hotel.check_in_time, parseFloat(time_allowed_entry_before_booking));
                var free_duration = this.hotel_conditions.free_duration;
                if (need_extra) {
                    this.entry_hotel_date = this.decrease_day_from_date(this.arrival_time_to_riyadh);
                    free_duration = parseInt(free_duration) + 1;
                } else {
                    this.entry_hotel_date = this.date_format(this.arrival_time_to_riyadh);
                }
                this.exit_hotel_date = this.add_days_to_date(this.entry_hotel_date, free_duration);
                if (this.exit_hotel_date > this.departure_time_for_riyadh) {
                    this.exit_hotel_date = this.date_format(this.departure_time_for_riyadh);
                }
                this.need_extra_end = this.need_an_extra_day_at_end(this.exit_hotel_date, this.departure_time_for_riyadh);
                if (this.tripType == 'oneway') {
                    this.exit_hotel_date = null;
                    this.entry_hotel_date = null;
                    this.need_extra_end = false;
                }
                if (this.need_extra_end) {
                    this.count_extra_end = this.count_extra_day_at_end(this.exit_hotel_date, this.departure_time_for_riyadh);
                    this.end_extra_date = this.add_days_to_date(this.exit_hotel_date, this.count_extra_end);
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.drawer-bar {
    width: 95%;
    display: block;
    border-bottom: 1px solid rgb(227, 232, 239);
    margin: 10px auto;
    border-bottom: 2px solid rgb(201, 211, 223);
}

.drawer-bar-item {
    width: 50%;
    height: 45px;
    font-size: 14px;
    border: none;
    background: none;
    position: relative;

}

.drawer-container {
    margin: auto;
    width: 100%;
    padding: 10px 0px;
}

.drawer-bar-item.active:before {
    content: "";
    height: 2px;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: -2px;
    transition: all .3s;
    transform: scale(1);
    background-color: var(--main-color);
}
.dash-line {
    border-top: 1px dashed #646464;
}
.ticket-hole {
    position: relative;
}
.ticket-hole:before {
    left: -28px;
}
.ticket-hole:after, .ticket-hole:before {
    content: '';
    width: 20px;
    height: 20px;
    background-color: var(--hole-bg-color);
    position: absolute;
    top: -12px;
    border-radius: 50%;
}
.ticket-hole:after {
    right: -28px;
}
.ticket-hole>hr {
    margin-top: 15px;
    margin-bottom: 15px;
    border-top: 1px dashed #646464;
}
@media (min-width: 768px) {
    .container {
        width: 750px;
    }
}
@media (min-width: 992px) {
    .container {
        width: 970px;
    }
}

@media (min-width: 1200px) {
    .container {
        width: 1350px;
    }
}

.color-label {
    color: #d1b26e!important;
    font-weight: 700!important;
    .note{
        color: rgb(192, 160, 52);
    }
}
.form-control{
        padding: 5px 22px;
        font-size: 14px;
        height: 40px;
        border-radius: 0.25rem;
}
label{
    font-size: 14px;
    margin-bottom: 8px;
    color: #d1b26e;
    font-weight: 600;
}
.form-group{
    margin-bottom: 1rem;
}
.section_padding {
    padding: 60px 0;
    background: var(--conf-bg-color);
}
.mb20 {
    margin-bottom: 20px !important;
}
.sticky-parent {
    bottom: 0px;
    position: sticky !important;
    top: 215px;
    height: 100%;
}

.fl-30-ico {
    background-image: url('~@/assets/img/icons/30x30.png');
    width: 30px;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
}
.mb0 {
    margin-bottom: 0px;
}
.h4,
h4 {
    font-size: 18px;
}
.no-margin {
    margin: 0;
}
.itinerary-content {
    background-color: var(--theme-search-form-bg);
    border-radius: 3px;
    padding-bottom: 5px;
}
.p10 {
    padding: 10px;
}

.bold {
    font-weight: 500;
    font-style: normal;
}
.ml5 {
    margin-left: 5px !important;
}

.mr5 {
    margin-right: 5px !important;
}
.hotel-img{
    width: 100%;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #a5a5a5;
    img{
        width: 100%;
    }
}
@media only screen and (max-width: 600px) {
    .sticky-parent {
        position: relative !important;
        top: 0px !important;
    }
    .hotel-img {
        min-height: 100% !important;
    }
    .opt-btn-div{
        button.btn{
            width: 50% !important;
        }
    }
}
</style>
<style lang="scss">
body:has(.fligh_confirmation) .lv-tooltip .lv-tooltip-text {
    background: #fff;
    color: #495057;
    white-space: initial;
    direction: ltr;
    min-width: 200px;
    padding: 5px 10px;

    div{
        border-bottom: 1px dashed #e0e0e0;
        line-height: 35px;
        font-size: 14px;
        &:last-child{
            border-bottom: none !important;
        }
    }
}
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: inherit;
    font-weight: 600;
    line-height: 1.1;
    color: inherit;
}
.section_padding {
    font-size: 14px;
    letter-spacing: .01em;
}
.itinerary-content {
    background-color: var(--theme-search-form-bg);
    border-radius: 3px;
    padding: 20px 10px;
    box-shadow: -4px -5px 14px rgba(0, 0, 0, 0.08), 5px 8px 16px rgba(0, 0, 0, 0.08);
}
.form-group:has(select) {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  .form-group select.form-control {
    width: 100%;
    padding: 5px 12px;
    border: 1px solid #ced4da;
    border-radius: 4px !important;
    font-size: 16px;
    color: var(--input-color);
    background-color: var(--flight-search-bg);
    appearance: none;
    outline: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
  }

  .form-group select.form-control:focus {
    border-color: var(--main-color);
  }

  
  .form-group:has(select):focus-within::after {
    transform: translateY(-50%) rotate(180deg);
  }
  .form-group select.form-control option {
    background-color: #fff;
    color: #495057;
    font-size: 16px;
    padding: 10px;
  }
  .form-group  select.form-control option:checked {
    background-color:  var(--main-color);
    color: #fff;
  }
.google-map{
    width: 100%; height: 400px;border: 1px solid #ced4da;border-radius: 6px;
}
.lv-dialog-mask {
    z-index: 10078;
}
.lv-dialog-content {
    overflow-y: hidden;
}
.lv-dialog .lv-dialog-header {
    padding: 1rem 1.5rem;
}
.lv-dialog .lv-dialog-footer {
    display: flex;
    justify-content: flex-end;
}
.lv-dialog .lv-dialog-content {
    padding: 0 1.5rem 1.5rem 1.5rem;
}
.lv-dialog .lv-dialog-header .lv-dialog-title {
    font-weight: 500;
    font-size: 1.1rem;
}
.rtl{
    .lv-button .lv-button__prepend {
        margin-left: 0.5rem;
    }
    .suffix-loader{
        left: 10px;
        right: unset;
    }
    .suffix-icon{
        left: 12px;
        right: unset;
    }
    .form-group:has(select)::after {
        left: 20px;
        right: unset;
    }
}
.form-group:has(select)::after {
    content: '';
    position: absolute;
    top: 70%;
    right: 20px;
    width: 0;
    height: 0;
    pointer-events: none;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #757575;
    transform: translateY(-50%);
  }
.suffix-loader{
    position: absolute;
    right: 10px;
    bottom: 6px;
}
.suffix-icon{
    position: absolute;
    right: 12px;
    bottom: 10px;
}
.fligh_confirmation{
    .lv-button {
        opacity: 1 !important;
        background-color: var(--main-color) !important;
    }
}
@media only screen and (max-width: 600px) {
    .lv-dialog {
        width: 95% !important;
    }
    .lv-dialog .lv-dialog-footer {
        padding: 1.5rem 1.5rem 1.5rem 1.5rem !important;
    }
}
</style>
<style scoped>
.footer .cta-outer-wrapper .cta-inner-wrapper .item .label-total-price {
    color: #212121;
    font-family: basic-sans-alt;
    font-weight: 700;
    font-size: 22px;
    letter-spacing: 0;
    line-height: 26px;
    margin: 0 0 16px
}

.footer:after {
    content: "";
    position: absolute;
    top: -34px;
    left: 16px;
    width: calc(100% - 16px - 16px);
    height: 34px;
    background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
    pointer-events: none
}

@media only screen and (min-width:612px) {
    .footer:after {
        top: -51px;
        left: 28px;
        width: calc(100% - 28px - 28px);
        height: 51px
    }
}

@media only screen and (min-width:924px) {
    .footer:after {
        top: -51px;
        left: 32%;
        width: 64%;
        height: 51px;
    }
}

.content .seat-selection-wrapper .group .passenger {
    display: block;
    -webkit-user-select: none;
    user-select: none;
    cursor: pointer;
}

.content .seat-selection-wrapper .group .active.passenger,
.content .seat-selection-wrapper .group .passenger:hover {
    border-radius: 4px;
    background-color: #eefff8
}

@media only screen and (max-width:611px) {
    .content {
        bottom: 146px
    }
}

@media only screen and (min-width:924px) {
    .content {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-content: center;
        align-items: center;
        align-items: flex-start;
        width: 100%;
        height: calc(100% - 60px);
    }
}

@media only screen and (min-width:924px) {
    .content .seat-map-wrapper,
    .content .seat-selection-wrapper {
        flex-grow: 0;
        flex-shrink: 1;
        flex-basis: auto;
        align-self: auto;
        min-width: 0;
        min-height: auto
    }
}

.content .seat-selection-wrapper {
    padding: 16px 21px 0
}

@media only screen and (min-width:612px) {
    .content .seat-selection-wrapper {
        padding: 28px 28px 0
    }
}

@media only screen and (min-width:924px) {
    .content .seat-selection-wrapper {
        width: 300px;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 32px 8px 0 25px
    }
}

.content .seat-selection-wrapper .group {
    margin-bottom: 14px
}

.content .seat-selection-wrapper .group:last-child {
    margin-bottom: 2px
}

.content .seat-selection-wrapper .group .flight {
    color: #212121;
    font-family: basic-sans-alt;
    font-weight: 400;
    font-size: 18px;
    letter-spacing: 0;
    line-height: 22px;
    margin: 0 0 6px
}

.content .seat-selection-wrapper .group .passenger {
    color: #424242;
    font-family: roboto;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 36px;
    margin: 0;
    padding: 0 14px;
    text-decoration: none
}

.content .seat-selection-wrapper .group .passenger.condensed-item {
    line-height: 26px
}

@media only screen and (max-width:923px) {
    .content .seat-map-wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-content: center;
        align-items: center
    }
}

@media only screen and (min-width:924px) {
    .content .seat-map-wrapper {
        margin-top: 14px;
        padding-left: 28px;
        padding-right: 28px;
        width: 650px;
        height: calc(100% - (32px - 18px));
        overflow-x: hidden;
        overflow-y: auto;
        padding-bottom: 25px;
    }
}

.content .seat-map-wrapper {
    margin-bottom: 34px
}

@media only screen and (min-width:612px) {
    .content .seat-map-wrapper {
        margin-bottom: 51px
    }
}

@media only screen and (min-width:924px) {
    .content .seat-map-wrapper {
        margin-bottom: 51px
    }
}

.footer {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center
}

@media only screen and (max-width:611px) {
    .footer {
        padding: 10px 0 16px
    }
}

@media only screen and (max-width:923px) {
    .footer {
        flex-wrap: wrap;
        position: absolute;
        left: 0;
        bottom: 0;
        padding: 10px 0 28px;
        background: #fff;
        box-sizing: border-box;
        width: 100%;
        height: 146px
    }
}

@media only screen and (min-width:924px) {
    .footer {
        position: relative;
        padding: 0px 32px 0px;
        box-sizing: border-box;
        align-items: center;
    }
}

.footer .cta-outer-wrapper,
.footer .legend-outer-wrapper {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    min-width: 0;
    min-height: auto;
    flex-basis: 100%
}

@media only screen and (min-width:924px) {
    .footer .cta-outer-wrapper,
    .footer .legend-outer-wrapper {
        flex-basis: 50%
    }
}

.footer .legend-outer-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    margin-bottom: 10px
}

@media only screen and (min-width:924px) {
    .footer .legend-outer-wrapper {
        margin: 0;
        justify-content: initial
    }
}

.footer .legend-outer-wrapper .legend-inner-wrapper,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend:not(:first-child) {
    margin-left: 14px
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .label {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    min-width: 0;
    min-height: auto
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box {
    width: 14px;
    height: 14px;
    border: 1px solid #8e9195;
    background-color: #fff;
    border-radius: 5px;
    box-sizing: border-box;
    margin-right: 8px
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.selected {
    border-color: var(--main-color);
    background-color: var(--main-color)
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.selected>div {
    color: #fff
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.available {
    border-color: var(--main-color)
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.available:not(.info-box) {
    cursor: pointer
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.available:hover:not(.selected, .info-box) {
    background-color: var(--main-color)
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.available:hover:not(.selected, .info-box) .seat-number {
    color: #fff
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked {
    border-color: #8e9195;
    background-color: #f5f5f5
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked:after,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked:before {
    background-color: #8e9195
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied {
    border-color: var(--main-color);
    background-color: #eefff8
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied:after,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied:before {
    background-color: var(--main-color)
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked {
    position: relative;
    overflow: hidden
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied:after,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied:before,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked:after,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked:before {
    content: "";
    position: absolute;
    top: -52.5%;
    width: 1px;
    height: 28px
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied:before,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked:before {
    transform: rotate(45deg);
    right: calc(50% + 1px)
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied:after,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked:after {
    transform: rotate(-45deg);
    left: calc(50% + 1px)
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied:not(.info-box),
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked:not(.info-box) {
    cursor: not-allowed
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied .seat-number,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked .seat-number {
    display: none
}

.footer .cta-outer-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center
}

@media only screen and (min-width:924px) {
    .footer .cta-outer-wrapper {
        justify-content: flex-end
    }
}

.footer .cta-outer-wrapper .cta-inner-wrapper {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    min-width: 0;
    min-height: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-direction: column;
    align-items: flex-end;
    min-width: 260px
}

.footer .cta-outer-wrapper .cta-inner-wrapper .item {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    min-width: 0;
    min-height: auto
}

.footer .cta-outer-wrapper .cta-inner-wrapper .item .btn-confirm {
    margin-left: 14px
}
.row-div .seat .seat-number {
    color: #424242;
    font-family: roboto;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 22px
}

.row-div .emergency-exit-row {
    position: relative
}

.row-div .emergency-exit-row:before {
    position: absolute;
    top: -12.5px;
    color: #ff5736;
    font-family: roboto-condensed;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
    line-height: 13px
}

@media only screen and (min-width:612px) {
    .row-div .emergency-exit-row:before {
        top: -15.5px
    }
}

@media only screen and (min-width:924px) {
    .row-div .emergency-exit-row:before {
        top: -15.5px
    }
}

.row-div .emergency-exit-row:after {
    position: absolute;
    top: -14px;
    width: 2px;
    height: 16px;
    background-color: #e2e3e4
}

@media only screen and (min-width:612px) {
    .row-div .emergency-exit-row:after {
        top: -17px
    }
}

@media only screen and (min-width:924px) {
    .row-div .emergency-exit-row:after {
        top: -17px
    }
}

.row-div .emergency-exit-row:first-child:before,
.row-div .emergency-exit-row:last-child:before {
    content: "EXIT"
}

.row-div .emergency-exit-row:first-child:after,
.row-div .emergency-exit-row:last-child:after {
    content: ""
}

.row-div .emergency-exit-row:first-child:before {
    left: 5px
}

.row-div .emergency-exit-row:first-child:after {
    left: 0
}

.row-div .emergency-exit-row:last-child:before {
    right: 5px
}

.row-div .emergency-exit-row:last-child:after {
    right: 0
}

.row-div .extra-legroom.seat-wrapper.emergency-exit-row:before {
    top: -18.5px
}

@media only screen and (min-width:612px) {
    .row-div .extra-legroom.seat-wrapper.emergency-exit-row:before {
        top: -24.5px
    }
}

@media only screen and (min-width:924px) {
    .row-div .extra-legroom.seat-wrapper.emergency-exit-row:before {
        top: -24.5px
    }
}

.row-div .extra-legroom.seat-wrapper.emergency-exit-row:after {
    top: -20px
}

@media only screen and (min-width:612px) {
    .row-div .extra-legroom.seat-wrapper.emergency-exit-row:after {
        top: -26px
    }
}

@media only screen and (min-width:924px) {
    .row-div .extra-legroom.seat-wrapper.emergency-exit-row:after {
        top: -26px
    }
}
.aircraft {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center
}

.aircraft .cabins-wrapper {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    min-width: 0;
    min-height: auto;
    flex-shrink: 0
}

.aircraft .cabins-wrapper .cabin {
    padding: 0 1px
}

@media only screen and (min-width:612px) {
    .aircraft .cabins-wrapper .cabin {
        padding: 0 4px
    }
}

@media only screen and (min-width:924px) {
    .aircraft .cabins-wrapper .cabin {
        padding: 0 4px
    }
}

.row-div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    align-items: flex-end
}

.row-div .aisle,
.row-div .seat-wrapper {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    min-width: 0;
    min-height: auto;
    margin: 12px 1px 0
}

@media only screen and (min-width:612px) {
    .row-div .aisle,
    .row-div .seat-wrapper {
        margin: 18px 4px 0
    }
}

@media only screen and (min-width:924px) {
    .row-div .aisle,
    .row-div .seat-wrapper {
        margin: 18px 4px 0
    }
}

.row-div .seat-wrapper.extra-legroom {
    margin-top: 24px
}

@media only screen and (min-width:612px) {
    .row-div .seat-wrapper.extra-legroom {
        margin-top: 36px
    }
}

@media only screen and (min-width:924px) {
    .row-div .seat-wrapper.extra-legroom {
        margin-top: 36px
    }
}

.row-div .seat {
    width: 28px;
    height: 28px;
    border: 1px solid #8e9195;
    background-color: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    -webkit-user-select: none;
    user-select: none
}

.row-div .seat.selected {
    border-color: var(--main-color);
    background-color: var(--main-color)
}

.row-div .seat.selected>div {
    color: #fff
}

.row-div .seat.available {
    border-color: var(--main-color)
}

.row-div .seat.available:not(.info-box) {
    cursor: pointer
}

.row-div .seat.available:hover:not(.selected, .info-box) {
    background-color: var(--main-color)
}

.row-div .seat.available:hover:not(.selected, .info-box) .seat-number {
    color: #fff
}

.row-div .seat.blocked {
    border-color: #8e9195;
    background-color: #f5f5f5
}

.row-div .seat.blocked:after,
.row-div .seat.blocked:before {
    background-color: #8e9195
}

.row-div .seat.occupied {
    border-color: var(--main-color);
    background-color: #eefff8
}

.row-div .seat.occupied:after,
.row-div .seat.occupied:before {
    background-color: var(--main-color)
}

.row-div .seat.occupied,
.row-div .seat.blocked {
    position: relative;
    overflow: hidden
}

.row-div .seat.occupied:after,
.row-div .seat.occupied:before,
.row-div .seat.blocked:after,
.row-div .seat.blocked:before {
    content: "";
    position: absolute;
    top: -52.5%;
    width: 1px;
    height: 56px
}

.row-div .seat.occupied:before,
.row-div .seat.blocked:before {
    transform: rotate(45deg);
    right: calc(50% + 1px)
}

.row-div .seat.occupied:after,
.row-div .seat.blocked:after {
    transform: rotate(-45deg);
    left: calc(50% + 1px)
}

.row-div .seat.occupied:not(.info-box),
.row-div .seat.blocked:not(.info-box) {
    cursor: not-allowed
}

.row-div .seat.occupied .seat-number,
.row-div .seat.blocked .seat-number {
    display: none
}

@media only screen and (min-width:612px) {
    .row-div .seat {
        width: 42px;
        height: 42px;
        border: 1px solid #8e9195;
        background-color: #fff;
        border-radius: 14px;
        box-sizing: border-box
    }
    .row-div .seat.selected {
        border-color: var(--main-color);
        background-color: var(--main-color)
    }
    .row-div .seat.selected>div {
        color: #fff
    }
    .row-div .seat.available {
        border-color: var(--main-color)
    }
    .row-div .seat.available:not(.info-box) {
        cursor: pointer
    }
    .row-div .seat.available:hover:not(.selected, .info-box) {
        background-color: var(--main-color)
    }
    .row-div .seat.available:hover:not(.selected, .info-box) .seat-number {
        color: #fff
    }
    .row-div .seat.blocked {
        border-color: #8e9195;
        background-color: #f5f5f5
    }
    .row-div .seat.blocked:after,
    .row-div .seat.blocked:before {
        background-color: #8e9195
    }
    .row-div .seat.occupied {
        border-color: var(--main-color);
        background-color: #eefff8
    }
    .row-div .seat.occupied:after,
    .row-div .seat.occupied:before {
        background-color: var(--main-color)
    }
    .row-div .seat.occupied,
    .row-div .seat.blocked {
        position: relative;
        overflow: hidden
    }
    .row-div .seat.occupied:after,
    .row-div .seat.occupied:before,
    .row-div .seat.blocked:after,
    .row-div .seat.blocked:before {
        content: "";
        position: absolute;
        top: -52.5%;
        width: 1px;
        height: 84px
    }
    .row-div .seat.occupied:before,
    .row-div .seat.blocked:before {
        transform: rotate(45deg);
        right: calc(50% + 1px)
    }
    .row-div .seat.occupied:after,
    .row-div .seat.blocked:after {
        transform: rotate(-45deg);
        left: calc(50% + 1px)
    }
    .row-div .seat.occupied:not(.info-box),
    .row-div .seat.blocked:not(.info-box) {
        cursor: not-allowed
    }
    .row-div .seat.occupied .seat-number,
    .row-div .seat.blocked .seat-number {
        display: none
    }
}

@media only screen and (min-width:924px) {
    .row-div .seat {
        width: 42px;
        height: 42px;
        border: 1px solid #8e9195;
        background-color: #fff;
        border-radius: 14px;
        box-sizing: border-box
    }
    .row-div .seat.selected {
        border-color: var(--main-color);
        background-color: var(--main-color)
    }
    .row-div .seat.selected>div {
        color: #fff
    }
    .row-div .seat.available {
        border-color: var(--main-color)
    }
    .row-div .seat.available:not(.info-box) {
        cursor: pointer
    }
    .row-div .seat.available:hover:not(.selected, .info-box) {
        background-color: var(--main-color)
    }
    .row-div .seat.available:hover:not(.selected, .info-box) .seat-number {
        color: #fff
    }
    .row-div .seat.blocked {
        border-color: #8e9195;
        background-color: #f5f5f5
    }
    .row-div .seat.blocked:after,
    .row-div .seat.blocked:before {
        background-color: #8e9195
    }
    .row-div .seat.occupied {
        border-color: var(--main-color);
        background-color: #eefff8
    }
    .row-div .seat.occupied:after,
    .row-div .seat.occupied:before {
        background-color: var(--main-color)
    }
    .row-div .seat.occupied,
    .row-div .seat.blocked {
        position: relative;
        overflow: hidden
    }
    .row-div .seat.occupied:after,
    .row-div .seat.occupied:before,
    .row-div .seat.blocked:after,
    .row-div .seat.blocked:before {
        content: "";
        position: absolute;
        top: -52.5%;
        width: 1px;
        height: 84px
    }
    .row-div .seat.occupied:before,
    .row-div .seat.blocked:before {
        transform: rotate(45deg);
        right: calc(50% + 1px)
    }
    .row-div .seat.occupied:after,
    .row-div .seat.blocked:after {
        transform: rotate(-45deg);
        left: calc(50% + 1px)
    }
    .row-div .seat.occupied:not(.info-box),
    .row-div .seat.blocked:not(.info-box) {
        cursor: not-allowed
    }
    .row-div .seat.occupied .seat-number,
    .row-div .seat.blocked .seat-number {
        display: none
    }
}

.row-div .seat .seat-number {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    width: 100%;
    height: 100%
}

@media only screen and (max-width:611px) {
    .row-div .seat .seat-number {
        font-size: 10px
    }
}

.row-div .aisle {
    width: 6px;
    height: 28px
}

@media only screen and (min-width:612px) {
    .row-div .aisle {
        width: 16px;
        height: 42px
    }
}

@media only screen and (min-width:924px) {
    .row-div .aisle {
        width: 16px;
        height: 42px
    }
}
@media only screen and (min-width: 924px) {
    .seatmap-container{
        flex-grow: 0;
        flex-shrink: 1;
        flex-basis: auto;
        align-self: auto;
        min-width: 0;
        min-height: auto;
        padding: 0;
        height: calc(100vh - 180px);
        direction: ltr;
        width: 100%;
    }
}
@media only screen and (min-width: 924px) {
    .p-seatmap {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-content: center;
        align-items: center;
        width: 100%;
    }
}
  .seat-map-wrapper::-webkit-scrollbar {
    width: 10px;
  }
  .seat-map-wrapper::-webkit-scrollbar-track {
    background: #f6f6f6;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
  }
  .seat-map-wrapper::-webkit-scrollbar-thumb {
    background: var(--main-color);
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
  }
  .seat-map-wrapper::-webkit-scrollbar-thumb:hover {
    background:  var(--main-color);
  }
  .ek-ancillary-container .clickable-wrapper {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    border: none;
}
.exbag-card {
    height: inherit;
    flex-direction: column;
    padding: 0;
    justify-content: space-between;
}
.exbag-card {
    letter-spacing: .02em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-smooth: never;
    display: flex;
    flex-direction: row;
    padding: 16px;
    border-radius: 8px;
    margin: 0;
    flex-grow: 1;
}
[lang="en"] .area_flex_one span.text-danger {
    font-weight: 500;
    padding-top: 5px;
    font-size: 14px;
    text-overflow: unset;
    overflow: auto;
    white-space: unset;
}
.form-check {
    padding-left:0;
}
</style>
